(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pusun-gradient-purchase"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('pusun-gradient-purchase')) return;
  class PusunGradientPurchase extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.mount());
    }
    mount() {
      if (!this.isConnected) return;
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.trigger = this.querySelector('[data-cost-open]');
      this.dialog = this.querySelector('[data-cost-dialog]');
      const closeButton = this.querySelector('[data-cost-close]');
      this.trigger?.addEventListener('click', () => {
        if (!this.dialog || this.dialog.open) return;
        this.dialog.showModal();
        closeButton?.focus({ preventScroll: true });
      }, options);
      closeButton?.addEventListener('click', () => this.dialog.close(), options);
      this.dialog?.addEventListener('close', () => {
        if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
      }, options);
      this.dialog?.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.addEventListener('shopify:block:select', event => {
        this.classList.add('pg-visible');
        if (event.target.closest('.pg-cost-group') && this.dialog && !this.dialog.open) this.dialog.showModal();
      }, options);
      if (this.dataset.revealEnabled !== 'true' || this.dataset.designMode === 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        this.classList.add('pg-visible');
        return;
      }
      this.classList.add('pg-ready');
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.classList.add('pg-visible');
          this.observer.disconnect();
        }
      }, { threshold: 0.1 });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.observer?.disconnect();
      if (this.dialog?.open) this.dialog.close();
    }
  }
  customElements.define('pusun-gradient-purchase', PusunGradientPurchase);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pusun-home-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('pusun-home-hero-section')) return;

  class PusunHomeHeroSection extends HTMLElement {
    connectedCallback() {
      if (this._controller || this._mountFrame) return;
      this._mountFrame = requestAnimationFrame(() => {
        this._mountFrame = 0;
        if (this.isConnected && !this._controller) this.mount();
      });
    }

    mount() {
      if (this._controller) return;
      this._controller = new AbortController();
      this._reasons = new Set();
      this._frame = 0;
      this._elapsed = 0;
      this._lastTime = null;
      this._pointer = null;
      this._focusOverride = false;
      this._hoverOverride = false;
      this._hovered = false;
      this._hasRendered = false;
      this._slides = Array.from(this.querySelectorAll('.phs-slide[data-slide]'));
      this._nav = Array.from(this.querySelectorAll('.phs-nav[data-slide]'));
      this._viewport = this.querySelector('.phs-viewport');
      this._controls = this.querySelector('.phs-controls');
      this._scroller = this.querySelector('.phs-nav-scroll');
      this._toggle = this.querySelector('.phs-toggle');
      this._status = this.querySelector('[data-status]');
      this._dialog = this.querySelector('.phs-dialog');
      this._videoHost = this.querySelector('.phs-video-host');
      this._fallback = this.querySelector('.phs-video-fallback');
      this._fallbackLink = this.querySelector('[data-video-fallback]');
      this._media = window.matchMedia('(prefers-reduced-motion: reduce)');
      const interval = Number(this.dataset.interval);
      this._interval = (Number.isFinite(interval) && interval > 0 ? Math.max(1, interval) : 5) * 1000;
      this._activeIndex = Math.max(0, this._slides.findIndex(slide => slide.classList.contains('is-active')));
      this._tick = time => this.tick(time);
      const signal = this._controller.signal;
      const listen = (target, type, callback, options = {}) => target?.addEventListener(type, callback, { ...options, signal });

      this._slides.forEach(slide => {
        slide.querySelectorAll('[data-enter]').forEach((group, index) => group.style.setProperty('--enter-delay', `${index * 70}ms`));
        slide.classList.remove('is-entering', 'is-first-ready');
      });
      if (this._controls) this._controls.hidden = this._slides.length < 2;
      if (this._toggle) this._toggle.hidden = this._slides.length < 2;
      if (this.dataset.autoplay !== 'true') this._reasons.add('user');
      if (this.dataset.editor === 'true' || window.Shopify?.designMode) this._reasons.add('editor');
      if (this._media.matches) this._reasons.add('reducedmotion');
      if (document.hidden) this._reasons.add('pagehidden');
      if (this.contains(document.activeElement)) this._reasons.add('focus');
      if (window.matchMedia('(hover: hover)').matches && this.matches(':hover')) {
        this._hovered = true;
        this._reasons.add('hover');
      }
      if ('IntersectionObserver' in window) {
        this._reasons.add('offscreen');
        this._observer = new IntersectionObserver(entries => {
          if (signal.aborted) return;
          const entry = entries.find(item => item.target === this);
          if (entry) this.setReason('offscreen', !entry.isIntersecting || entry.intersectionRatio < 0.05);
        }, { threshold: [0, 0.05] });
        this._observer.observe(this);
      }

      listen(this, 'click', event => {
        const target = event.target instanceof Element ? event.target : event.target.parentElement;
        if (!target) return;
        const nav = target.closest('.phs-nav[data-slide]');
        if (nav && this.contains(nav)) {
          this.goToSlide(nav.dataset.slide, true);
          nav.focus({ preventScroll: true });
          return;
        }
        if (target.closest('.phs-toggle')) {
          if (this.canPlay()) this.setReason('user', true);
          else this.resume();
          return;
        }
        if (target.closest('[data-video-close]')) {
          this.closeVideo();
          return;
        }
        const trigger = target.closest('[data-video-url]');
        if (trigger && this.contains(trigger)) this.openVideo(trigger.dataset.videoUrl, trigger);
      });
      listen(this.querySelector('.phs-nav-list'), 'keydown', event => {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        const current = event.target.closest('.phs-nav[data-slide]');
        const buttons = this._nav.filter(button => !button.hidden && !button.disabled);
        const index = buttons.indexOf(current);
        if (index < 0 || !buttons.length) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = buttons.length - 1;
        else return;
        event.preventDefault();
        this.goToSlide(buttons[next].dataset.slide, true);
        buttons[next].focus({ preventScroll: true });
      });
      listen(this, 'pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        this._hovered = true;
        if (!this._hoverOverride) this.setReason('hover', true);
      });
      listen(this, 'pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        this._hovered = false;
        this._hoverOverride = false;
        this.setReason('hover', false);
      });
      listen(this, 'focusin', () => {
        if (!this._focusOverride) this.setReason('focus', true);
      });
      listen(this, 'focusout', () => queueMicrotask(() => {
        if (signal.aborted || this.contains(document.activeElement)) return;
        this._focusOverride = false;
        this.setReason('focus', false);
      }));
      listen(document, 'visibilitychange', () => this.setReason('pagehidden', document.hidden));
      listen(this._media, 'change', event => {
        this.setReason('reducedmotion', event.matches);
        if (event.matches) {
          this._slides.forEach(slide => {
            slide.classList.remove('is-entering');
            slide.getAnimations?.({ subtree: true }).forEach(animation => animation.cancel());
          });
        }
      });
      listen(this._viewport, 'pointerdown', event => {
        if (!event.isPrimary) {
          this._pointer = null;
          return;
        }
        if (event.button !== 0 || this._slides.length < 2) return;
        if (event.target.closest('a, button, input, select, textarea, dialog, [contenteditable], .phs-controls')) return;
        this._pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, time: performance.now() };
      }, { passive: true });
      listen(window, 'pointerup', event => {
        const start = this._pointer;
        this._pointer = null;
        if (!start || event.pointerId !== start.id || performance.now() - start.time > 1500) return;
        const x = event.clientX - start.x;
        const y = event.clientY - start.y;
        if (Math.abs(x) < 40 || Math.abs(x) < Math.abs(y) * 1.3) return;
        const index = (this._activeIndex + (x < 0 ? 1 : -1) + this._slides.length) % this._slides.length;
        this.goToSlide(this._slides[index].dataset.slide, true);
      }, { passive: true });
      listen(window, 'pointercancel', () => { this._pointer = null; }, { passive: true });
      listen(this._dialog, 'cancel', event => {
        event.preventDefault();
        this.closeVideo();
      });
      listen(this._dialog, 'close', () => {
        if (!this._dialog.open) this.clearVideo();
      });
      listen(this._dialog, 'click', event => {
        if (event.target !== this._dialog) return;
        const rect = this._dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeVideo();
      });
      listen(document, 'shopify:section:select', event => {
        if (!this.matchesEditorSection(event)) return;
        this.setReason('editor', true);
        this.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
      });
      listen(document, 'shopify:block:select', event => {
        const slide = event.target instanceof Element ? event.target.closest('.phs-slide[data-slide]') : null;
        if (!slide || !this.contains(slide)) return;
        this.setReason('editor', true);
        this.goToSlide(slide.dataset.slide, true);
      });
      listen(document, 'shopify:section:deselect', event => {
        if (this.matchesEditorSection(event) && this.dataset.editor !== 'true' && !window.Shopify?.designMode) this.setReason('editor', false);
      });

      this.renderActive(false);
      this._slides[this._activeIndex]?.classList.add('is-first-ready');
      this.syncPlayback();
    }

    disconnectedCallback() {
      if (this._mountFrame) cancelAnimationFrame(this._mountFrame);
      this._mountFrame = 0;
      this._controller?.abort();
      this._observer?.disconnect();
      this._observer = null;
      this.stopClock();
      this._pointer = null;
      if (this._dialog?.open) this._dialog.close();
      this.clearVideo();
      this._slides?.forEach(slide => {
        slide.classList.remove('is-entering', 'is-first-ready');
        slide.getAnimations?.({ subtree: true }).forEach(animation => animation.cancel());
      });
      this._controller = null;
    }

    matchesEditorSection(event) {
      const id = event.detail?.sectionId;
      return id != null ? String(id) === this.dataset.sectionId : event.target instanceof Element && event.target.contains(this);
    }

    canPlay() {
      return Boolean(this.isConnected && this._controller && !this._controller.signal.aborted && this._slides.length > 1 && this._reasons.size === 0);
    }

    setReason(name, paused) {
      if (!this._reasons) return;
      if (paused) this._reasons.add(name);
      else this._reasons.delete(name);
      this.syncPlayback();
    }

    resume() {
      this._focusOverride = this.contains(document.activeElement);
      this._hoverOverride = this._hovered;
      ['user', 'focus', 'hover', 'reducedmotion', 'editor'].forEach(reason => this._reasons.delete(reason));
      this.syncPlayback();
    }

    stopClock() {
      if (this._lastTime != null) this._elapsed = Math.min(this._interval, this._elapsed + Math.max(0, performance.now() - this._lastTime));
      if (this._frame) cancelAnimationFrame(this._frame);
      this._frame = 0;
      this._lastTime = null;
    }

    syncPlayback() {
      const playing = this.canPlay();
      if (!playing) this.stopClock();
      else if (!this._frame) {
        this._lastTime = performance.now();
        this._frame = requestAnimationFrame(this._tick);
      }
      this.dataset.playing = String(playing);
      if (this._toggle) {
        const label = playing ? this.dataset.labelPause || 'Pause slideshow' : this.dataset.labelResume || 'Play slideshow';
        this._toggle.setAttribute('aria-label', label);
        this._toggle.setAttribute('title', label);
        this._toggle.querySelector('[data-pause-icon]')?.toggleAttribute('hidden', !playing);
        this._toggle.querySelector('[data-play-icon]')?.toggleAttribute('hidden', playing);
      }
      this.renderProgress();
    }

    tick(time) {
      this._frame = 0;
      if (!this.canPlay()) {
        this._lastTime = null;
        return;
      }
      if (this._lastTime != null) this._elapsed += Math.max(0, time - this._lastTime);
      this._lastTime = time;
      if (this._elapsed >= this._interval) {
        const next = this._slides[(this._activeIndex + 1) % this._slides.length];
        this.goToSlide(next.dataset.slide);
      } else this.renderProgress();
      if (this.canPlay() && !this._frame) this._frame = requestAnimationFrame(this._tick);
    }

    renderProgress() {
      if (!this._slides?.length) return;
      const id = this._slides[this._activeIndex].dataset.slide;
      const progress = Math.min(1, Math.max(0, this._elapsed / this._interval));
      this._nav.forEach(button => {
        const fill = button.querySelector('.phs-progress-fill');
        if (fill) fill.style.transform = `scaleX(${button.dataset.slide === id ? progress : 0})`;
      });
    }

    goToSlide(number, manual = false) {
      if (!this._slides?.length) return false;
      const index = this._slides.findIndex(slide => slide.dataset.slide === String(number));
      if (index < 0) return false;
      if (manual) this._reasons.add('user');
      const changed = index !== this._activeIndex;
      this._activeIndex = index;
      this._elapsed = 0;
      this._lastTime = this.canPlay() ? performance.now() : null;
      if (changed) this.renderActive(manual);
      if (manual && this._status) {
        const slide = this._slides[index];
        this._status.textContent = slide.dataset.navLabel || slide.querySelector('h1, h2, h3')?.textContent?.trim() || '';
      }
      this.syncPlayback();
      return true;
    }

    renderActive(manual) {
      const active = this._slides[this._activeIndex];
      if (!active) return;
      this._slides.forEach(slide => {
        const selected = slide === active;
        slide.classList.toggle('is-active', selected);
        slide.setAttribute('aria-hidden', String(!selected));
        slide.inert = !selected;
        slide.classList.remove('is-entering', 'is-first-ready');
      });
      if (active.dataset.navColor) this.style.setProperty('--nav-color', active.dataset.navColor);
      if (active.dataset.navSurface) this.style.setProperty('--nav-surface', active.dataset.navSurface);
      if (active.dataset.navSolid) this.style.setProperty('--nav-solid', active.dataset.navSolid);
      this._nav.forEach(button => {
        const selected = button.dataset.slide === active.dataset.slide;
        button.classList.toggle('is-active', selected);
        if (selected) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
      if (this._hasRendered && !this._media.matches) {
        void active.offsetWidth;
        active.classList.add('is-entering');
      }
      this._hasRendered = true;
      const button = this._nav.find(item => item.dataset.slide === active.dataset.slide);
      if (button && this._scroller) {
        const bounds = this._scroller.getBoundingClientRect();
        const item = button.getBoundingClientRect();
        this._scroller.scrollTo({ left: this._scroller.scrollLeft + item.left - bounds.left + item.width / 2 - this._scroller.clientWidth / 2, behavior: manual && !this._media.matches ? 'smooth' : 'auto' });
      }
      this.renderProgress();
    }

    parseVideoURL(raw) {
      let url;
      try { url = new URL(String(raw || '').trim()); } catch { return null; }
      if (url.protocol !== 'https:' || url.username || url.password) return null;
      const host = url.hostname.toLowerCase();
      const parts = url.pathname.split('/').filter(Boolean);
      const youtubeHosts = ['youtube.com', 'www.youtube.com', 'm.youtube.com', 'music.youtube.com', 'youtube-nocookie.com', 'www.youtube-nocookie.com'];
      let id;
      if (host === 'youtu.be' || host === 'www.youtu.be') id = parts[0];
      else if (youtubeHosts.includes(host)) id = parts[0] === 'watch' ? url.searchParams.get('v') : ['embed', 'shorts', 'live'].includes(parts[0]) ? parts[1] : null;
      if (id && /^[A-Za-z0-9_-]{11}$/.test(id)) {
        const embed = new URL(`https://www.youtube-nocookie.com/embed/${id}`);
        embed.search = 'autoplay=1&playsinline=1&rel=0';
        const rawStart = url.searchParams.get('start') || url.searchParams.get('t') || url.hash.match(/(?:^#|[&])t=([^&]+)/)?.[1];
        const time = String(rawStart || '').match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s?)?$/);
        const seconds = time ? Number(time[1] || 0) * 3600 + Number(time[2] || 0) * 60 + Number(time[3] || 0) : 0;
        if (seconds > 0) embed.searchParams.set('start', String(Math.floor(seconds)));
        return { type: 'iframe', provider: 'youtube', src: embed.href, fallback: url.href };
      }
      if (['vimeo.com', 'www.vimeo.com', 'player.vimeo.com'].includes(host)) {
        const index = parts.findIndex(part => /^\d+$/.test(part));
        if (index >= 0 && (host !== 'player.vimeo.com' || parts[0] === 'video')) {
          const embed = new URL(`https://player.vimeo.com/video/${parts[index]}`);
          embed.search = 'autoplay=1&title=0&byline=0&portrait=0&dnt=1';
          const hash = url.searchParams.get('h') || parts[index + 1];
          if (hash && /^[A-Za-z0-9]+$/.test(hash)) embed.searchParams.set('h', hash);
          return { type: 'iframe', provider: 'vimeo', src: embed.href, fallback: url.href };
        }
      }
      if (/\.(mp4|webm)$/i.test(url.pathname)) return { type: 'video', src: url.href, fallback: url.href };
      return { type: 'link', src: url.href, fallback: url.href };
    }

    openVideo(raw, trigger) {
      const video = this.parseVideoURL(raw);
      if (!video || !this._dialog || !this._videoHost || typeof this._dialog.showModal !== 'function') return false;
      this.clearVideo(false);
      this._videoTrigger = trigger;
      this.setReason('modal', true);
      this._videoController = new AbortController();
      const signal = this._videoController.signal;
      if (this._fallbackLink) {
        this._fallbackLink.href = video.fallback;
        this._fallbackLink.target = '_blank';
        this._fallbackLink.rel = 'noopener noreferrer';
        if (this.dataset.labelOpenVideo) this._fallbackLink.textContent = this.dataset.labelOpenVideo;
      }
      if (this._fallback) this._fallback.hidden = video.type !== 'link';
      this._videoHost.hidden = video.type === 'link';
      if (video.type === 'iframe') {
        const iframe = document.createElement('iframe');
        iframe.title = this.dataset.labelVideo || 'Product video';
        iframe.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        iframe.src = video.src;
        this._videoHost.append(iframe);
      } else if (video.type === 'video') {
        const player = document.createElement('video');
        player.controls = true;
        player.playsInline = true;
        player.autoplay = true;
        player.preload = 'metadata';
        player.setAttribute('aria-label', this.dataset.labelVideo || 'Product video');
        player.addEventListener('error', () => {
          if (this._fallback) this._fallback.hidden = false;
        }, { signal });
        player.src = video.src;
        this._videoHost.append(player);
      }
      if (!this._dialog.open) this._dialog.showModal();
      this._videoHost.querySelector('video')?.play().catch(() => {});
      return true;
    }

    closeVideo() {
      if (this._dialog?.open) this._dialog.close();
      this.clearVideo();
    }

    clearVideo(resume = true) {
      this._videoController?.abort();
      this._videoController = null;
      this._videoHost?.querySelectorAll('video').forEach(video => {
        video.pause();
        video.removeAttribute('src');
        video.load();
      });
      this._videoHost?.querySelectorAll('iframe').forEach(iframe => { iframe.src = 'about:blank'; });
      this._videoHost?.replaceChildren();
      if (this._fallback) this._fallback.hidden = true;
      this._fallbackLink?.removeAttribute('href');
      if (resume) {
        this.setReason('modal', false);
        if (this.isConnected && this._videoTrigger?.isConnected && !this.contains(document.activeElement)) this._videoTrigger.focus({ preventScroll: true });
        this._videoTrigger = null;
      }
    }
  }

  customElements.define('pusun-home-hero-section', PusunHomeHeroSection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pusun-ps-fine-settings"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('ps-fine-settings')) return;
  class PsFineSettings extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const { signal } = this._controller;
      const init = () => {
        if (signal.aborted || !this.isConnected || this.hasAttribute('data-ready')) return;
        this._motion = matchMedia('(prefers-reduced-motion: reduce)');
        this._animations = new Set();
        this._minus = this.querySelector('[data-fine-minus]');
        this._plus = this.querySelector('[data-fine-plus]');
        this._output = this.querySelector('[data-fine-value]');
        this._screens = this.querySelectorAll('[data-fine-screen-value]');
        this._tenths = Number.isInteger(this._tenths) ? Math.max(110, Math.min(750, this._tenths)) : 280;
        this._minus?.addEventListener('click', () => this.adjust(-1), { signal });
        this._plus?.addEventListener('click', () => this.adjust(1), { signal });
        this.renderValue();
        this.setAttribute('data-ready', '');
        this.initReveal();
        this._motion.addEventListener('change', () => {
          if (this._motion.matches) this.finishReveal();
        }, { signal });
        ['shopify:block:select', 'shopify:section:select'].forEach(type => {
          document.addEventListener(type, event => {
            if (event.target instanceof Element && (event.target === this || this.contains(event.target) || event.target.contains(this))) this.finishReveal();
          }, { signal });
        });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true, signal });
      else queueMicrotask(init);
    }
    adjust(delta) {
      this._tenths = Math.max(110, Math.min(750, this._tenths + delta));
      this.renderValue();
    }
    renderValue() {
      const value = (this._tenths / 10).toFixed(1);
      if (this._output) this._output.value = value;
      this._screens?.forEach(screen => { screen.textContent = value; });
      if (this._minus) this._minus.disabled = this._tenths <= 110;
      if (this._plus) this._plus.disabled = this._tenths >= 750;
    }
    initReveal() {
      const elements = [...this.querySelectorAll('[data-fine-reveal]')];
      if (this.dataset.reveal !== 'true' || this._motion.matches || !('IntersectionObserver' in window)) {
        elements.forEach(element => element.setAttribute('data-fine-revealed', ''));
        return;
      }
      this._observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this._observer.unobserve(entry.target);
          if (entry.target.hasAttribute('data-fine-revealed')) return;
          entry.target.setAttribute('data-fine-revealed', '');
          if (this._motion.matches || !entry.target.animate) return;
          const frames = entry.target.dataset.fineReveal === 'image'
            ? [{ opacity: 0, transform: 'scale(.94)' }, { opacity: 1, transform: 'scale(1)' }]
            : [{ opacity: 0, transform: 'translateY(24px)' }, { opacity: 1, transform: 'translateY(0)' }];
          const animation = entry.target.animate(frames, { duration: 1100, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' });
          this._animations.add(animation);
          animation.finished.then(() => this._animations.delete(animation)).catch(() => {});
        });
      }, { threshold: .08 });
      elements.filter(element => !element.hasAttribute('data-fine-revealed')).forEach(element => this._observer.observe(element));
    }
    finishReveal() {
      this._observer?.disconnect();
      this.querySelectorAll('[data-fine-reveal]').forEach(element => element.setAttribute('data-fine-revealed', ''));
      this._animations?.forEach(animation => { try { animation.finish(); } catch (_) { animation.cancel(); } });
      this._animations?.clear();
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._observer?.disconnect();
      this._animations?.forEach(animation => animation.cancel());
      this._animations?.clear();
      if (this._minus) this._minus.disabled = true;
      if (this._plus) this._plus.disabled = true;
      this.removeAttribute('data-ready');
      this._controller = null;
    }
  }
  customElements.define('ps-fine-settings', PsFineSettings);
})();

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pusun-ps-height-animation"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('ps-height-animation')) return;
  class PsHeightAnimation extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const { signal } = this._controller;
      const init = () => {
        if (signal.aborted || !this.isConnected || this.hasAttribute('data-ready')) return;
        this._motion = matchMedia('(prefers-reduced-motion: reduce)');
        this._animations = new Set();
        this._video = this.querySelector('video');
        if (this._video) this.initVideo(signal);
        this.setAttribute('data-ready', '');
        this.initReveal();
        this._motion.addEventListener('change', () => {
          if (!this._motion.matches) return;
          this.finishAnimations();
          this._stopAutomatic?.();
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          if (event.target === this || this.contains(event.target) || event.target.contains(this)) this.finishAnimations();
        }, { signal });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true, signal });
      else queueMicrotask(init);
    }
    finishAnimations() {
      this._animations?.forEach(animation => { try { animation.finish(); } catch (_) { animation.cancel(); } });
      this._animations?.clear();
    }
    animateElement(element, frames, options = {}) {
      if (!element?.animate || this._motion.matches) return;
      const animation = element.animate(frames, { duration: 760, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards', ...options });
      this._animations.add(animation);
      animation.finished.then(() => this._animations.delete(animation)).catch(() => {});
    }
    initReveal() {
      if (this.dataset.reveal !== 'true' || !('IntersectionObserver' in window)) return;
      this._revealObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this._revealObserver.unobserve(entry.target);
          if (this._motion.matches) return;
          if (entry.target.dataset.heightEntry === 'copy') {
            entry.target.querySelectorAll('[data-height-reveal]').forEach((element, index) => this.animateElement(element, [
              { opacity: 0, transform: 'translateY(20px)' }, { opacity: 1, transform: 'translateY(0)' }
            ], { delay: index * 85 }));
            this.animateElement(entry.target.querySelector('.pshgt__ruler'), [
              { opacity: 0, transform: 'scaleY(.25)' }, { opacity: 1, transform: 'scaleY(1)' }
            ], { delay: 200, duration: 980 });
          } else {
            this.animateElement(entry.target, [{ opacity: .3, transform: 'scale(.98)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 900 });
          }
        });
      }, { threshold: .08 });
      this.querySelectorAll('[data-height-entry]').forEach(element => this._revealObserver.observe(element));
    }
    initVideo(signal) {
      const video = this._video;
      // Forward and reverse motion is encoded in the asset for smooth mobile playback.
      video.controls = false;
      video.removeAttribute('controls');
      video.loop = true;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.disablePictureInPicture = true;
      video.setAttribute('disablepictureinpicture', '');
      video.setAttribute('disableremoteplayback', '');
      let visible = false;
      let readyToAutoplay = false;
      let started = false;
      const sync = () => {
        if (!visible || document.hidden || this._motion.matches || this.dataset.autoplay !== 'true') {
          video.pause();
          return;
        }
        if (!readyToAutoplay && !started) return;
        started = true;
        video.play().catch(() => {});
      };
      this._stopAutomatic = sync;
      this._motion.addEventListener('change', sync, { signal });
      video.addEventListener('play', () => {
        if (!visible || document.hidden || this._motion.matches || this.dataset.autoplay !== 'true') video.pause();
      }, { signal });
      if ('IntersectionObserver' in window) {
        this._videoObserver = new IntersectionObserver(entries => {
          visible = entries[0].isIntersecting && entries[0].intersectionRatio > 0;
          readyToAutoplay = visible && entries[0].intersectionRatio >= .45;
          sync();
        }, { threshold: [0, .45] });
        this._videoObserver.observe(video);
      }
      document.addEventListener('visibilitychange', sync, { signal });
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._revealObserver?.disconnect();
      this._videoObserver?.disconnect();
      this._animations?.forEach(animation => animation.cancel());
      this._video?.pause();
      this._stopAutomatic = null;
      this.removeAttribute('data-ready');
      this._controller = null;
    }
  }
  customElements.define('ps-height-animation', PsHeightAnimation);
})();

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pusun-ps-job-setup"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('ps-job-setup')) return;
  class PsJobSetup extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const { signal } = this._controller;
      const init = () => {
        if (signal.aborted || !this.isConnected || this.hasAttribute('data-ready')) return;
        this.setAttribute('data-ready', '');
        this._motion = matchMedia('(prefers-reduced-motion: reduce)');
        this._animations = new Set();
        const finish = () => { this._animations.forEach(a => a.finish()); this._animations.clear(); };
        if ('IntersectionObserver' in window && this.dataset.reveal === 'true') {
          this._observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;
              this._observer.unobserve(entry.target);
              if (this._motion.matches || !entry.target.animate) return;
              const image = entry.target.dataset.jobReveal === 'image';
              const animation = entry.target.animate([
                { opacity: image ? .3 : 0, transform: image ? 'scale(.94)' : 'translateY(24px)' },
                { opacity: 1, transform: image ? 'scale(1)' : 'translateY(0)' }
              ], { duration: image ? 850 : 700, easing: 'cubic-bezier(.22,1,.36,1)' });
              this._animations.add(animation);
              animation.finished.then(() => this._animations.delete(animation)).catch(() => {});
            });
          }, { threshold: .08 });
          this.querySelectorAll('[data-job-reveal]').forEach(el => this._observer.observe(el));
        }
        this._video = this.querySelector('video');
        if (this._video) this.initVideo(signal);
        this._motion.addEventListener('change', () => {
          if (this._motion.matches) { finish(); this._video?.pause(); }
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          if (event.target === this || this.contains(event.target) || event.target.contains(this)) finish();
        }, { signal });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true, signal });
      else queueMicrotask(init);
    }
    initVideo(signal) {
      const video = this._video;
      let visible = false, userPaused = false, environmentPause = false, resume = false;
      video.addEventListener('pause', () => {
        if (!environmentPause) userPaused = true;
        environmentPause = false;
      }, { signal });
      video.addEventListener('play', () => { userPaused = false; }, { signal });
      const sync = () => {
        if (!visible || document.hidden) {
          resume = resume || !video.paused;
          if (!video.paused) { environmentPause = true; video.pause(); }
        } else if (!userPaused && !this._motion.matches && (resume || this.dataset.autoplay === 'true')) {
          resume = false;
          video.play().catch(() => {});
        }
      };
      if ('IntersectionObserver' in window) {
        this._videoObserver = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, { threshold: .15 });
        this._videoObserver.observe(video);
      }
      document.addEventListener('visibilitychange', sync, { signal });
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._observer?.disconnect();
      this._videoObserver?.disconnect();
      this._animations?.forEach(a => a.cancel());
      this._video?.pause();
      this.removeAttribute('data-ready');
      this._controller = null;
    }
  }
  customElements.define('ps-job-setup', PsJobSetup);
})();

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pusun-ps-machine-controls"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('ps-machine-controls')) return;
  class PsMachineControls extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const signal = this._controller.signal;
      const init = () => {
        if (signal.aborted || !this.isConnected || this.hasAttribute('data-ready')) return;
        this._tabs = [...this.querySelectorAll('[data-pmc-tab]')];
        this._panels = [...this.querySelectorAll('[data-pmc-panel]')];
        this._seen = new WeakSet();
        this._animations = new Map();
        this._active = -1;
        this._slide = { x: 0, velocity: 0, target: 0 };
        this._direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        this._line = { x: 0, velocity: 0, target: 0 };
        this._lineWidth = { x: 0, velocity: 0, target: 0 };
        this._height = { x: 0, velocity: 0, target: 0 };
        this._motion = matchMedia('(prefers-reduced-motion: reduce)');
        const list = this._list = this.querySelector('[data-pmc-tabs]');
        this._indicator = this.querySelector('[data-pmc-indicator]');
        this._stage = this.querySelector('[data-pmc-stage]');
        this._track = this.querySelector('[data-pmc-track]');
        if (!list || !this._indicator || !this._stage || !this._track || this._tabs.length !== 3 || this._panels.length !== 3) return;
        this.initMediaRail();
        list.hidden = false;
        list.setAttribute('role', 'tablist');
        const heading = this.querySelector('.psmc__heading');
        if (heading) {
          heading.id = this.id + '-Heading';
          list.setAttribute('aria-labelledby', heading.id);
        }
        this._tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          this._panels[index].setAttribute('role', 'tabpanel');
          this._panels[index].setAttribute('aria-labelledby', tab.id);
          this._panels[index].tabIndex = 0;
          this._rails.forEach(rail => { rail.pages[index].style.transform = `translate3d(${index * this._direction * 100}%, 0, 0)`; });
          tab.addEventListener('click', () => this.select(index, true), { signal });
          tab.addEventListener('keydown', (event) => {
            let next;
            const rtl = getComputedStyle(this).direction === 'rtl';
            if (event.key === 'ArrowRight') next = index + (rtl ? -1 : 1);
            if (event.key === 'ArrowLeft') next = index + (rtl ? 1 : -1);
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = 2;
            if (next === undefined) return;
            event.preventDefault();
            next = (next + 3) % 3;
            this.select(next, true);
            this._tabs[next].focus({ preventScroll: true });
          }, { signal });
        });
        this.setAttribute('data-ready', '');
        this.select(0, false);
        // Load only this component's three media assets before the first switch.
        this.querySelectorAll('img').forEach(img => {
          img.loading = 'eager';
          img.addEventListener('load', () => this.updateGeometry(), { signal });
        });
        const layoutChanged = () => this.updateGeometry();
        window.addEventListener('resize', layoutChanged, { passive: true, signal });
        if ('ResizeObserver' in window) {
          // Observe natural panel sizes, never the animated stage height.
          this._resizeObserver = new ResizeObserver(layoutChanged);
          this._resizeObserver.observe(list);
          this._rails.forEach(rail => rail.pages.forEach(page => this._resizeObserver.observe(page)));
        }
        document.fonts?.ready.then(() => { if (!signal.aborted) this.updateGeometry(); });
        // Progressive enhancement: nothing is hidden in CSS while waiting for an observer.
        if ('IntersectionObserver' in window) {
          this._observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting || entry.target.closest('[hidden], [aria-hidden="true"]')) return;
              this.reveal(entry.target, false);
              this._observer.unobserve(entry.target);
            });
          }, { threshold: 0.05 });
          this.querySelectorAll('[data-pmc-reveal]').forEach(el => this._observer.observe(el));
        }
        this._motion.addEventListener('change', () => {
          if (this._motion.matches) {
            this.settleTransitions();
            this._animations.forEach(animation => animation.cancel());
            this._animations.clear();
            this._video?.pause();
          }
        }, { signal });
        this.initVideo(signal);
        document.addEventListener('shopify:block:select', event => {
          if (event.target === this || event.target.contains(this) || this.contains(event.target)) {
            this.settleTransitions();
            this._animations.forEach(animation => animation.finish());
          }
        }, { signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.settleTransitions();
        }, { signal });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true, signal });
      else queueMicrotask(init);
    }
    initMediaRail() {
      // Start with paired image + copy in the HTML. Enhance into two synchronized
      // rails so the navigation remains still and each column moves in its own frame.
      const stage = document.createElement('div');
      stage.className = 'psmc__media-stage';
      stage.dataset.pmcMediaStage = '';
      const track = document.createElement('div');
      track.className = 'psmc__media-track';
      track.dataset.pmcMediaTrack = '';
      stage.append(track);
      const pages = this._panels.map((panel, index) => {
        const page = document.createElement('div');
        page.className = 'psmc__media-panel';
        page.dataset.pmcMediaPanel = '';
        page.id = this.id + '-Media-' + (index + 1);
        const media = panel.querySelector('.psmc__image-wrap, .psmc__placeholder');
        if (media) page.append(media);
        track.append(page);
        return page;
      });
      this.querySelector('.psmc__explorer').prepend(stage);
      this.dataset.images = String(pages.some(page => page.childElementCount));
      this._mediaStage = stage;
      this._mediaTrack = track;
      this._mediaPanels = pages;
      this._mediaHeight = { x: 0, velocity: 0, target: 0 };
      this._rails = [
        { stage: this._stage, track: this._track, pages: this._panels, height: this._height },
        { stage, track, pages, height: this._mediaHeight }
      ];
    }
    select(index, animate) {
      if (!this._tabs[index] || this._active === index) return;
      const moving = animate && this.dataset.reveal === 'true' && !this._motion.matches;
      // Both rails share one progress/velocity, like a synchronized slide deck.
      // Retarget without resetting position or velocity on a rapid reversal.
      this._active = index;
      this._slide.target = index;
      this._tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        this._panels[i].tabIndex = selected ? 0 : -1;
        this._rails.forEach(rail => {
          const panel = rail.pages[i];
          panel.setAttribute('aria-hidden', String(!selected));
          panel.inert = !selected;
          panel.dataset.active = String(selected);
          panel.hidden = false;
        });
      });
      if (moving) {
        this._rails.forEach(rail => rail.pages.forEach(panel => panel.querySelectorAll('[data-pmc-reveal]').forEach(el => {
            this._seen.add(el);
            this._observer?.unobserve(el);
            // Entry effects belong to the first reveal, not to each slide change.
            this._animations.get(el)?.finish();
          })));
        this._rails.forEach(rail => { rail.track.style.willChange = 'transform'; });
        this.updateGeometry();
      } else this.settleTransitions();
    }
    updateGeometry(instant = false) {
      if (!this.isConnected || !this._tabs?.[this._active]) return;
      const listRect = this._list.getBoundingClientRect();
      const tabRect = this._tabs[this._active].getBoundingClientRect();
      this._line.target = tabRect.left - listRect.left + this._list.scrollLeft;
      this._lineWidth.target = tabRect.width;
      this._rails.forEach(rail => { rail.height.target = rail.pages[this._active].offsetHeight; });
      if (instant || this._motion.matches || this.dataset.reveal !== 'true') this.snapGeometry();
      else this.startMotion();
    }
    startMotion() {
      if (this._frame) return;
      this._lastFrame = performance.now();
      this._frame = requestAnimationFrame(time => this.tickMotion(time));
    }
    advanceSpring(state, dt, tolerance = 0.025) {
      // Critically damped, like the workflow section: responsive, with a soft finish.
      const omega = 12;
      const distance = state.x - state.target;
      const coefficient = state.velocity + omega * distance;
      const decay = Math.exp(-omega * dt);
      state.x = state.target + (distance + coefficient * dt) * decay;
      state.velocity = (state.velocity - omega * coefficient * dt) * decay;
      if (Math.abs(state.x - state.target) < tolerance && Math.abs(state.velocity) < tolerance * omega) {
        state.x = state.target;
        state.velocity = 0;
        return true;
      }
      return false;
    }
    tickMotion(time) {
      const dt = Math.min(Math.max((time - this._lastFrame) / 1000, 0), 0.05);
      this._lastFrame = time;
      const geometryDone = [this._line, this._lineWidth, this._height, this._mediaHeight].map(state => this.advanceSpring(state, dt)).every(Boolean);
      const slidesDone = this.advanceSpring(this._slide, dt, 0.00004);
      const done = geometryDone && slidesDone;
      this.paintGeometry();
      if (done) {
        this._frame = 0;
        this._rails.forEach(rail => { rail.track.style.willChange = ''; });
        this.hideInactivePanels();
      } else this._frame = requestAnimationFrame(next => this.tickMotion(next));
    }
    paintGeometry() {
      this._indicator.style.width = Math.max(0, this._lineWidth.x) + 'px';
      this._indicator.style.transform = `translate3d(${this._line.x}px, 0, 0)`;
      this._rails.forEach(rail => {
        rail.stage.style.height = Math.max(0, rail.height.x) + 'px';
        rail.track.style.transform = `translate3d(${-this._slide.x * this._direction * 100}%, 0, 0)`;
      });
    }
    snapGeometry() {
      cancelAnimationFrame(this._frame);
      this._frame = 0;
      [this._line, this._lineWidth, this._height, this._mediaHeight, this._slide].forEach(state => { state.x = state.target; state.velocity = 0; });
      this.paintGeometry();
      this._rails.forEach(rail => { rail.track.style.willChange = ''; });
      this.hideInactivePanels();
    }
    hideInactivePanels() {
      this._rails.forEach(rail => rail.pages.forEach((panel, index) => {
        panel.hidden = index !== this._active;
      }));
    }
    settleTransitions() {
      this._slide.target = this._active;
      this.updateGeometry(true);
    }
    reveal(el, isSwitch) {
      if (!isSwitch && this._seen.has(el)) return;
      this._seen.add(el);
      this._observer?.unobserve(el);
      if (this.dataset.reveal !== 'true' || this._motion.matches || !el.animate) return;
      this._animations.get(el)?.cancel();
      const image = el.dataset.pmcReveal === 'image';
      const frames = image
        ? [{ opacity: 0.3, transform: 'scale(' + (isSwitch ? '.98' : '.92') + ')' }, { opacity: 1, transform: 'scale(1)' }]
        : [{ opacity: 0, transform: 'translateY(' + (isSwitch ? '10' : '28') + 'px)' }, { opacity: 1, transform: 'translateY(0)' }];
      const animation = el.animate(frames, { duration: isSwitch ? 280 : image ? 900 : 720, easing: 'cubic-bezier(.22,1,.36,1)' });
      this._animations.set(el, animation);
      animation.finished.then(() => {
        if (this._animations.get(el) === animation) this._animations.delete(el);
      }).catch(() => {});
    }
    initVideo(signal) {
      this._video = this.querySelector('video');
      const video = this._video;
      if (!video) return;
      let userPaused = false;
      let environmentPause = false;
      let visible = false;
      let resume = false;
      video.addEventListener('pause', () => {
        if (!environmentPause) userPaused = true;
        environmentPause = false;
      }, { signal });
      video.addEventListener('play', () => { userPaused = false; }, { signal });
      const sync = () => {
        if (!visible || document.hidden) {
          resume = resume || !video.paused;
          if (!video.paused) { environmentPause = true; video.pause(); }
        } else if (!userPaused && !this._motion.matches && (resume || this.dataset.autoplay === 'true')) {
          resume = false;
          video.play().catch(() => {});
        }
      };
      if ('IntersectionObserver' in window) {
        this._videoObserver = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, { threshold: 0.15 });
        this._videoObserver.observe(video);
      }
      document.addEventListener('visibilitychange', sync, { signal });
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._observer?.disconnect();
      this._resizeObserver?.disconnect();
      this._videoObserver?.disconnect();
      this._animations?.forEach(animation => animation.cancel());
      cancelAnimationFrame(this._frame);
      this._frame = 0;
      this._video?.pause();
      this._controller = null;
      this.removeAttribute('data-ready');
      this.removeAttribute('data-images');
      this._mediaPanels?.forEach((page, index) => {
        if (page.firstElementChild) this._panels[index].prepend(page.firstElementChild);
      });
      this._mediaStage?.remove();
      if (this._list) this._list.hidden = true;
      if (this._stage) this._stage.style.height = '';
      if (this._track) { this._track.style.transform = ''; this._track.style.willChange = ''; }
      this._panels?.forEach(panel => {
        panel.hidden = false;
        panel.inert = false;
        panel.removeAttribute('aria-hidden');
        panel.style.opacity = '';
        panel.style.transform = '';
        panel.style.willChange = '';
      });
    }
  }
  customElements.define('ps-machine-controls', PsMachineControls);
})();

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pusun-ps-routine"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('ps-routine')) return;
  class PsRoutine extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const { signal } = this._controller;
      const init = () => {
        if (signal.aborted || !this.isConnected || this.hasAttribute('data-ready')) return;
        this._motion = matchMedia('(prefers-reduced-motion: reduce)');
        this._mobile = matchMedia('(max-width: 899px)');
        this._animations = new Set();
        this._cards = Array.from(this.querySelectorAll('.psroutine__card')).map(el => ({
          el, button:el.querySelector('.psroutine__toggle'), detail:el.querySelector('.psroutine__detail'),
          w:1, v:0, p:0, pv:0, height:0, collapsed:420
        }));
        this._active = null;
        this.dataset.active = '';
        this.setAttribute('data-ready','');
        this._cards.forEach(card => {
          card.el.removeAttribute('data-open');
          card.button.setAttribute('aria-expanded','false');
          card.detail.inert = true;
          card.detail.setAttribute('aria-hidden','true');
          card.button.addEventListener('click', () => this.select(this._active === card ? null : card), {signal});
        });
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && this._active) {
            event.preventDefault(); const button = this._active.button;
            this.select(null); button.focus({preventScroll:true});
          }
        }, {signal});
        this.measure();
        this.paint();
        let lastWidth = this.getBoundingClientRect().width;
        this._resize = new ResizeObserver(() => {
          const width = this.getBoundingClientRect().width;
          if (Math.abs(width-lastWidth) < .5) return;
          lastWidth=width; this.measure(); this.paint();
        });
        this._resize.observe(this);
        this._mobile.addEventListener('change', () => {this.measure();this.paint();}, {signal});
        document.fonts?.ready.then(() => {if (!signal.aborted) {this.measure();this.paint();}});
        this._motion.addEventListener('change', () => {
          if (this._motion.matches) {this.finishReveal(); this.settle();}
        }, {signal});
        const selected = event => {
          if (event.target instanceof Element && (event.target === this || this.contains(event.target) || event.target.contains(this))) this.finishReveal();
        };
        document.addEventListener('shopify:block:select', selected, {signal});
        document.addEventListener('shopify:section:select', selected, {signal});
        if (this.dataset.reveal === 'true' && !this._motion.matches && 'IntersectionObserver' in window) {
          this._observer = new IntersectionObserver(entries => entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            this._observer.unobserve(entry.target);
            if (entry.target.hasAttribute('data-routine-revealed')) return;
            entry.target.setAttribute('data-routine-revealed','');
            if (!entry.target.animate || this._motion.matches) return;
            const image = entry.target.dataset.routineReveal === 'image';
            const animation = entry.target.animate([
              {opacity:image ? .65 : 0, transform:image ? 'scale(.94)' : 'translateY(24px)'},
              {opacity:1, transform:image ? 'scale(1)' : 'translateY(0)'}
            ], {duration:1100, easing:'cubic-bezier(.22,1,.36,1)'});
            this._animations.add(animation);
            animation.finished.then(() => this._animations.delete(animation)).catch(() => {});
          }), {threshold:.08});
          this.querySelectorAll('[data-routine-reveal]').forEach(el => {
            if (!el.hasAttribute('data-routine-revealed')) this._observer.observe(el);
          });
        } else this.finishReveal();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true,signal});
      else queueMicrotask(init);
    }
    measure() {
      const row=this.querySelector('.psroutine__cards');
      if (!row || !this._cards.length) return;
      const mobile=this._mobile.matches;
      const gap=parseFloat(getComputedStyle(row).gap)||0;
      const total=row.clientWidth-gap*(this._cards.length-1);
      const expanded=mobile ? row.clientWidth : total*2.6/(this._cards.length+1.6);
      const equal=mobile ? row.clientWidth : total/this._cards.length;
      this._desktopHeight=580;
      for (const card of this._cards) {
        const inset=parseFloat(getComputedStyle(card.el.querySelector('.psroutine__caption')).left)||28;
        const clone=card.el.querySelector('.psroutine__caption-inner').cloneNode(true);
        clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
        clone.style.cssText=`position:fixed;left:-10000px;top:0;width:${Math.max(1,expanded-inset*2)}px;visibility:hidden;pointer-events:none;`;
        const detail=clone.querySelector('.psroutine__detail');
        detail.style.cssText='height:auto;opacity:1;transform:none;overflow:visible;';
        this.append(clone);
        card.height=detail.getBoundingClientRect().height;
        const full=clone.getBoundingClientRect().height;
        clone.style.width=Math.max(1,equal-inset*2)+'px';
        const title=clone.querySelector('.psroutine__scene-title')?.getBoundingClientRect().height||0;
        card.collapsed=Math.max(420,title+180);
        this._desktopHeight=Math.max(this._desktopHeight,full+200,title+180);
        clone.remove();
      }
    }
    select(card) {
      this._active=card;
      this.dataset.active=card?.el.dataset.scene||'';
      this._cards.forEach(item => {
        const open=item===card;
        if (!open && item.detail.contains(document.activeElement)) item.button.focus({preventScroll:true});
        item.el.toggleAttribute('data-open',open);
        item.button.setAttribute('aria-expanded',String(open));
        item.detail.inert=!open;
        item.detail.setAttribute('aria-hidden',String(!open));
      });
      if (this._motion.matches) {this.settle();return;}
      if (!this._frame) {
        this._time=performance.now();
        this._frame=requestAnimationFrame(t => this.tick(t));
      }
    }
    tick(time) {
      const dt=Math.min((time-this._time)/1000,.034);this._time=time;
      const omega=13, decay=Math.exp(-omega*dt);
      let moving=false;
      for (const card of this._cards) {
        for (const [key,velocity,target] of [['w','v',card===this._active?2.6:1],['p','pv',card===this._active?1:0]]) {
          const x=card[key]-target, step=(card[velocity]+omega*x)*dt;
          card[key]=target+(x+step)*decay;
          card[velocity]=(card[velocity]-omega*step)*decay;
          if (Math.abs(card[key]-target)>.0005 || Math.abs(card[velocity])>.005) moving=true;
          else {card[key]=target;card[velocity]=0;}
        }
      }
      this.paint();
      this._frame=moving?requestAnimationFrame(t => this.tick(t)):null;
    }
    paint() {
      for (const card of this._cards||[]) {
        const p=Math.max(0,Math.min(1,card.p));
        card.el.style.setProperty('--pr-flex',card.w);
        card.el.style.setProperty('--pr-card-height',(this._mobile.matches?card.collapsed+card.height*p:this._desktopHeight)+'px');
        card.el.style.setProperty('--pr-detail-height',(card.height*p)+'px');
        card.el.style.setProperty('--pr-detail-opacity',p*p);
        card.el.style.setProperty('--pr-detail-y',(12*(1-p))+'px');
      }
    }
    settle() {
      cancelAnimationFrame(this._frame);this._frame=null;
      this._cards.forEach(card => {card.w=card===this._active?2.6:1;card.p=card===this._active?1:0;card.v=card.pv=0;});
      this.paint();
    }
    finishReveal() {
      this._observer?.disconnect();
      this.querySelectorAll('[data-routine-reveal]').forEach(el => el.setAttribute('data-routine-revealed',''));
      this._animations?.forEach(animation => animation.finish());
      this._animations?.clear();
    }
    disconnectedCallback() {
      this._controller?.abort();this._observer?.disconnect();this._resize?.disconnect();
      cancelAnimationFrame(this._frame);this._frame=null;
      this._animations?.forEach(animation => animation.cancel());
      this._cards?.forEach(card => {card.detail.inert=false;card.detail.removeAttribute('aria-hidden');['--pr-flex','--pr-card-height','--pr-detail-height','--pr-detail-opacity','--pr-detail-y'].forEach(key => card.el.style.removeProperty(key));});
      this.removeAttribute('data-ready');this._controller=null;
    }
  }
  customElements.define('ps-routine',PsRoutine);
})();

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pusun-ps-tension-test"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('ps-tension-test')) return;
  class PsTensionTest extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const { signal } = this._controller;
      const init = () => {
        if (signal.aborted || !this.isConnected) return;
        this._video = this.querySelector('video');
        this._stage = this.querySelector('.pttest__stage');
        this._toggle = this.querySelector('[data-test-toggle]');
        this._motion = matchMedia('(prefers-reduced-motion: reduce)');
        this._animations = new Set();
        this._visible = false;
        this._manual = null;
        if (this._video) {
          const video = this._video;
          video.controls = false;
          video.removeAttribute('controls');
          video.muted = true;
          video.defaultMuted = true;
          video.loop = true;
          video.playsInline = true;
          video.tabIndex = -1;
          video.pause();
          const sync = () => {
            const paused = video.paused;
            this.dataset.paused = String(paused);
            this._toggle?.setAttribute('aria-label', paused ? this._toggle.dataset.playLabel : this._toggle.dataset.pauseLabel);
          };
          this._sync = sync;
          ['play','pause','ended','error'].forEach(type => video.addEventListener(type, sync, { signal }));
          if (this._toggle) {
            this._toggle.hidden = false;
            this._toggle.addEventListener('click', () => {
              if (video.paused) {
                this._manual = 'play';
                video.play().catch(() => sync());
              } else {
                this._manual = 'pause';
                video.pause();
              }
              sync();
            }, { signal });
          }
          sync();
          if ('IntersectionObserver' in window) {
            this._playObserver = new IntersectionObserver(entries => {
              this._visible = entries.some(entry => entry.isIntersecting);
              this.updatePlayback();
            }, { threshold: 0.01 });
            this._playObserver.observe(this._stage);
          } else {
            this._visible = true;
            this.updatePlayback();
          }
          document.addEventListener('visibilitychange', () => this.updatePlayback(), { signal });
        }
        const elements = [...this.querySelectorAll('[data-test-reveal]')];
        this._finish = () => {
          this._observer?.disconnect();
          this._animations.forEach(animation => { try { animation.finish(); } catch (_) { animation.cancel(); } });
          elements.forEach(element => element.setAttribute('data-test-revealed',''));
        };
        if (this.dataset.reveal !== 'true' || this._motion.matches || !('IntersectionObserver' in window)) this._finish();
        else {
          this._observer = new IntersectionObserver(entries => entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            const element = entry.target;
            this._observer.unobserve(element);
            if (element.hasAttribute('data-test-revealed')) return;
            element.setAttribute('data-test-revealed','');
            const image = element.dataset.testReveal === 'image';
            const animation = element.animate([{opacity:0,transform:image?'scale(.94)':'translateY(24px)'},{opacity:1,transform:'none'}],{duration:1100,easing:'cubic-bezier(.22,1,.36,1)',fill:'backwards'});
            this._animations.add(animation);
            animation.finished.then(()=>this._animations.delete(animation)).catch(()=>{});
          }), { threshold:.08 });
          elements.forEach(element=>this._observer.observe(element));
        }
        this._motion.addEventListener('change', () => {
          if (this._motion.matches) this._finish();
          this.updatePlayback();
        }, { signal });
        ['shopify:section:select','shopify:block:select'].forEach(type=>document.addEventListener(type,event=>{
          if(event.target instanceof Element && (event.target===this||event.target.contains(this)||this.contains(event.target)))this._finish();
        },{signal}));
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true,signal});
      else queueMicrotask(init);
    }
    updatePlayback() {
      if (!this._video) return;
      const shouldPlay = this._visible && !document.hidden && this._manual !== 'pause' && (!this._motion.matches || this._manual === 'play');
      if (shouldPlay) this._video.play().catch(() => this._sync?.());
      else { this._video.pause(); this._sync?.(); }
    }
    disconnectedCallback() {
      this._controller?.abort();
      this._observer?.disconnect();
      this._playObserver?.disconnect();
      this._animations?.forEach(a=>a.cancel());
      this._video?.pause();
      this._controller = null;
    }
  }
  customElements.define('ps-tension-test',PsTensionTest);
})();

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pusun-pt-9001-highlights"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag = 'pusun-9001-highlights';
  if (customElements.get(tag)) return;
  const instances = new Map();
  function refreshControls() {
    let closest = null;
    let distance = Infinity;
    instances.forEach(instance => {
      if (!instance.visible()) return;
      const next = instance.distance();
      if (next < distance) { closest = instance; distance = next; }
    });
    instances.forEach(instance => instance.own(instance === closest));
  }
  function mount(root) {
    const $ = selector => root.querySelector(selector);
    const track = $('.pusun-highlights__track');
    const gallery = $('.pusun-highlights__gallery');
    const slides = [...root.querySelectorAll('[data-slide-index]')];
    const dots = [...root.querySelectorAll('[data-dot-index]')];
    const controls = $('.pusun-highlights__controls');
    const playButton = $('.pusun-highlights__play');
    if (!track || !gallery || !slides.length || !controls || !playButton) return null;
    const abort = new AbortController();
    const on = (element, event, handler, options = {}) => element.addEventListener(event, handler, { ...options, signal: abort.signal });
    const mediaQuery = matchMedia('(max-width: 749px)');
    const motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
    const allVideos = [...root.querySelectorAll('video')];
    const failed = new WeakSet();
    const pendingPlay = new WeakSet();
    const observers = [];
    const imageDuration = Math.max(3, Number(root.dataset.duration) || 6) * 1000;
    let active = 0;
    let wantsPlay = root.dataset.autoplay === 'true' && !motionQuery.matches;
    let completed = false;
    let visible = false;
    let near = false;
    let destroyed = false;
    let moving = false;
    let hasEntered = false;
    let elapsed = 0;
    let lastTime = 0;
    let frame = 0;
    let viewportFrame = 0;
    let settleTimer = 0;
    let scrollFallback = 0;
    let pointer = null;
    const wrapperFor = index => slides[index]?.querySelector(`[data-device="${mediaQuery.matches ? 'mobile' : 'desktop'}"]`);
    const videoFor = index => wrapperFor(index)?.querySelector('video') || null;
    const canRun = () => wantsPlay && visible && !document.hidden && !moving && !completed && !destroyed;
    function setProgress(value) {
      dots[active]?.style.setProperty('--highlights-progress', String(Math.max(0, Math.min(1, value || 0))));
    }
    function paintControls() {
      const playing = canRun();
      root.classList.toggle('is-playing', playing);
      playButton.dataset.paused = String(!playing);
      playButton.dataset.complete = String(completed);
      playButton.setAttribute('aria-label', completed ? 'Replay highlights' : playing ? 'Pause highlights' : 'Play highlights');
      dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === active)));
      const status = $('[data-status]');
      if (status) status.textContent = `Highlight ${active + 1} of ${slides.length}`;
      gallery.setAttribute('aria-live', wantsPlay ? 'off' : 'polite');
    }
    function prepare(index) {
      const wrapper = wrapperFor(index);
      if (!wrapper) return;
      wrapper.querySelectorAll('img').forEach(img => { img.loading = 'eager'; img.decoding = 'async'; });
      const video = wrapper.querySelector('video');
      if (!video || video.getAttribute('src') || !video.dataset.hdSrc) return;
      video.muted = true;
      video.defaultMuted = true;
      video.preload = 'auto';
      video.src = video.dataset.hdSrc;
      video.load();
    }
    function prepareNearby() {
      if (!near && !visible) return;
      prepare(active);
      if (root.dataset.preloadNext === 'true') prepare(active + 1);
    }
    function stopFrame() {
      cancelAnimationFrame(frame); frame = 0; lastTime = 0;
    }
    function pauseOtherVideos(keep = null) {
      allVideos.forEach(video => { if (video !== keep && !video.paused) video.pause(); });
    }
    function finishSlide() {
      stopFrame();
      if (active < slides.length - 1) navigate(active + 1, false);
      else {
        completed = true; wantsPlay = false; setProgress(1);
        pauseOtherVideos(); paintControls();
      }
    }
    function tick(time) {
      frame = 0;
      if (!canRun()) { lastTime = 0; return; }
      const video = videoFor(active);
      if (video && !failed.has(video)) {
        if (Number.isFinite(video.duration) && video.duration > 0) setProgress(video.currentTime / video.duration);
        if (video.ended) { finishSlide(); return; }
      } else {
        if (lastTime) elapsed += Math.min(100, time - lastTime);
        setProgress(elapsed / imageDuration);
        if (elapsed >= imageDuration) { finishSlide(); return; }
      }
      lastTime = time;
      frame = requestAnimationFrame(tick);
    }
    function syncPlayback() {
      prepareNearby();
      const video = videoFor(active);
      if (!canRun()) { pauseOtherVideos(); stopFrame(); paintControls(); return; }
      pauseOtherVideos(video && !failed.has(video) ? video : null);
      if (video && !failed.has(video) && video.paused && !pendingPlay.has(video)) {
        pendingPlay.add(video);
        Promise.resolve(video.play()).then(() => {
          pendingPlay.delete(video);
          if (destroyed || !canRun() || video !== videoFor(active)) video.pause();
        }).catch(error => {
          pendingPlay.delete(video);
          if (error?.name === 'AbortError') {
            if (!destroyed && canRun() && video === videoFor(active)) syncPlayback();
            return;
          }
          // A blocked autoplay is a user-controlled pause, never a silent skip.
          if (!destroyed && video === videoFor(active) && canRun()) {
            wantsPlay = false; syncPlayback();
          }
        });
      }
      if (!frame) frame = requestAnimationFrame(tick);
      paintControls();
    }
    function manualPause() { wantsPlay = false; completed = false; syncPlayback(); }
    function destination(index) {
      const rect = slides[index].getBoundingClientRect();
      const trackRect = track.getBoundingClientRect();
      const inset = mediaQuery.matches ? parseFloat(getComputedStyle(track).paddingLeft) || 0 : (track.clientWidth - rect.width) / 2;
      return Math.max(0, Math.min(track.scrollWidth - track.clientWidth, track.scrollLeft + rect.left - trackRect.left - inset));
    }
    function nearest() {
      let index = 0; let best = Infinity;
      slides.forEach((_, candidate) => {
        const distance = Math.abs(destination(candidate) - track.scrollLeft);
        if (distance < best) { index = candidate; best = distance; }
      });
      return index;
    }
    function select(index) {
      if (index !== active) {
        pauseOtherVideos();
        active = index; elapsed = 0; lastTime = 0; completed = false;
        const video = videoFor(active);
        if (video && video.readyState > 0) { try { video.currentTime = 0; } catch (_) {} }
        setProgress(0);
      }
      syncPlayback();
    }
    function settle() {
      clearTimeout(settleTimer); clearTimeout(scrollFallback);
      moving = false;
      select(nearest());
      revealVisible();
    }
    function navigate(index, manual = true) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      if (manual) manualPause();
      prepare(index);
      if (root.dataset.preloadNext === 'true') prepare(index + 1);
      const left = destination(index);
      if (Math.abs(left - track.scrollLeft) < 1) { select(index); return; }
      moving = true; syncPlayback();
      track.scrollTo({ left, behavior: motionQuery.matches ? 'instant' : 'smooth' });
      clearTimeout(scrollFallback);
      scrollFallback = setTimeout(settle, 1100);
    }
    function revealHeading() {
      const header = $('.pusun-highlights__header');
      if (!header || root.classList.contains('is-revealed')) return;
      const rect = header.getBoundingClientRect();
      if (rect.top < window.innerHeight - 40 && rect.bottom > 0) root.classList.add('is-revealed');
    }
    function revealVisible() {
      if (destroyed) return;
      // Check both axes: the next-card peek is eligible, offscreen cards are not.
      // The track itself never transforms, so scroll-snap destinations stay stable.
      const viewport = track.getBoundingClientRect();
      const top = Math.max(0, viewport.top);
      const bottom = Math.min(window.innerHeight - 40, viewport.bottom);
      if (bottom <= top) return;
      let order = 0;
      slides.forEach(slide => {
        const rect = slide.getBoundingClientRect();
        if (rect.right <= viewport.left + 2 || rect.left >= viewport.right - 2 || rect.bottom <= top || rect.top >= bottom) return;
        if (!slide.classList.contains('is-slide-revealed')) {
          const delay = hasEntered ? 0 : Math.min(order, 3) * 90;
          slide.style.setProperty('--highlights-card-reveal-delay', `${delay}ms`);
          slide.classList.add('is-slide-revealed'); order++;
        }
        // A tall mobile card can enter while its text is still above/below view.
        const copy = slide.querySelector('.pusun-highlights__copy');
        if (copy && !slide.classList.contains('is-copy-revealed')) {
          const copyRect = copy.getBoundingClientRect();
          if (copyRect.bottom > top && copyRect.top < bottom && copyRect.right > viewport.left + 2 && copyRect.left < viewport.right - 2) slide.classList.add('is-copy-revealed');
        }
      });
      if (order) hasEntered = true;
    }
    function finishReveals() {
      // Editor selection, focused controls and reduced motion must expose content immediately.
      root.classList.add('is-revealed', 'is-reveal-complete');
      slides.forEach(slide => {
        slide.style.setProperty('--highlights-card-reveal-delay', '0ms');
        slide.classList.add('is-slide-revealed', 'is-copy-revealed');
      });
      hasEntered = true;
    }
    function checkViewport() {
      viewportFrame = 0;
      const rect = gallery.getBoundingClientRect();
      const height = window.innerHeight;
      const rootRect = root.getBoundingClientRect();
      near = rootRect.top < height + 700 && rootRect.bottom > -700;
      const intersection = Math.min(rect.bottom, height) - Math.max(rect.top, 0);
      // Controls appear only while a useful part of the gallery is on screen.
      const nextVisible = intersection >= Math.min(160, height * .2, rect.height * .25);
      revealHeading();
      if (visible !== nextVisible) { visible = nextVisible; syncPlayback(); }
      prepareNearby(); revealVisible(); refreshControls();
    }
    function queueViewport() { if (!viewportFrame) viewportFrame = requestAnimationFrame(checkViewport); }
    instances.set(root, {
      visible: () => visible && !document.hidden,
      distance: () => { const rect = gallery.getBoundingClientRect(); return Math.abs((rect.top + rect.bottom) / 2 - innerHeight / 2); },
      own: owner => {
        root.classList.toggle('is-gallery-visible', owner);
        controls.setAttribute('aria-hidden', String(!owner)); controls.inert = !owner;
      }
    });
    allVideos.forEach(video => {
      const markReady = () => video.parentElement.classList.add('is-frame-ready');
      on(video, 'loadeddata', markReady); on(video, 'playing', markReady);
      on(video, 'error', () => {
        failed.add(video); video.parentElement.classList.add('is-media-error');
        if (video === videoFor(active)) { elapsed = 0; syncPlayback(); }
      });
      on(video, 'ended', () => { if (video === videoFor(active) && canRun()) finishSlide(); });
    });
    dots.forEach((dot, index) => on(dot, 'click', () => navigate(index)));
    on(playButton, 'click', () => {
      if (canRun()) manualPause();
      else {
        if (completed) {
          completed = false; elapsed = 0; setProgress(0);
          if (active === 0) { const video = videoFor(active); if (video?.readyState) video.currentTime = 0; }
          wantsPlay = true; navigate(0, false);
        } else { wantsPlay = true; syncPlayback(); }
      }
    });
    on(track, 'keydown', event => {
      let index;
      if (event.key === 'ArrowRight') index = nearest() + 1;
      if (event.key === 'ArrowLeft') index = nearest() - 1;
      if (event.key === 'Home') index = 0;
      if (event.key === 'End') index = slides.length - 1;
      if (index !== undefined) { event.preventDefault(); navigate(index); }
    });
    on(track, 'scroll', () => {
      if (!moving) { moving = true; syncPlayback(); }
      revealVisible(); clearTimeout(settleTimer); settleTimer = setTimeout(settle, 130);
    }, { passive: true });
    on(track, 'scrollend', settle);
    on(track, 'pointerdown', event => {
      pointer = { x: event.clientX, y: event.clientY, moved: false };
    }, { passive: true });
    on(track, 'pointermove', event => {
      if (!pointer || pointer.moved) return;
      const dx = Math.abs(event.clientX - pointer.x), dy = Math.abs(event.clientY - pointer.y);
      if (dx > 12 && dx > dy * 1.2) {
        pointer.moved = true; manualPause();
        // Interrupt an in-flight programmed scroll at its current position.
        if (moving) track.scrollTo({ left: track.scrollLeft, behavior: 'instant' });
      }
    }, { passive: true });
    on(window, 'pointerup', () => { pointer = null; }, { passive: true });
    on(window, 'pointercancel', () => { pointer = null; }, { passive: true });
    on(track, 'wheel', event => { if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) manualPause(); }, { passive: true });
    // Keyboard users can read a card without the carousel advancing away.
    on(root, 'focusin', event => { finishReveals(); if (event.target !== playButton) manualPause(); });
    on(window, 'beforeprint', finishReveals);
    on(window, 'scroll', queueViewport, { passive: true });
    on(window, 'resize', queueViewport, { passive: true });
    on(document, 'visibilitychange', () => { syncPlayback(); refreshControls(); });
    on(mediaQuery, 'change', () => {
      pauseOtherVideos(); moving = false; prepareNearby();
      track.scrollTo({ left: destination(active), behavior: 'instant' });
      syncPlayback(); queueViewport();
    });
    on(motionQuery, 'change', () => {
      if (motionQuery.matches) { finishReveals(); manualPause(); }
      root.classList.toggle('is-motion-ready', root.dataset.revealEnabled === 'true' && !motionQuery.matches);
      queueViewport();
    });
    on(document, 'shopify:block:select', event => {
      if (event.target === root || root.contains(event.target)) { finishReveals(); manualPause(); }
    });
    on(document, 'shopify:section:select', event => {
      if (event.target === root || event.target?.contains?.(root)) { finishReveals(); manualPause(); }
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(queueViewport, { rootMargin: '700px 0px', threshold: [0, .1, .5, 1] });
      observer.observe(root); observers.push(observer);
    }
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(queueViewport); observer.observe(root); observers.push(observer);
    }
    root.classList.toggle('is-motion-ready', root.dataset.revealEnabled === 'true' && !motionQuery.matches);
    if (motionQuery.matches) finishReveals();
    paintControls(); queueViewport();
    return () => {
      destroyed = true; abort.abort(); pauseOtherVideos(); stopFrame();
      cancelAnimationFrame(viewportFrame); clearTimeout(settleTimer); clearTimeout(scrollFallback);
      observers.forEach(observer => observer.disconnect());
      instances.delete(root); refreshControls();
      root.classList.remove('is-motion-ready', 'is-gallery-visible', 'is-playing');
      controls.inert = true; controls.setAttribute('aria-hidden', 'true');
    };
  }
  class Pusun9001Highlights extends HTMLElement {
    connectedCallback() {
      if (this._pt9001Cleanup) return;
      const start = () => {
        if (!this.isConnected || this._pt9001Cleanup || !this.querySelector('[data-highlights-ready]')) return;
        this._pt9001ReadyObserver?.disconnect();
        this._pt9001Cleanup = mount(this);
      };
      if (this.querySelector('[data-highlights-ready]')) start();
      else {
        this._pt9001ReadyObserver?.disconnect();
        this._pt9001ReadyObserver = new MutationObserver(start);
        this._pt9001ReadyObserver.observe(this, { childList: true, subtree: true });
      }
    }
    disconnectedCallback() {
      this._pt9001ReadyObserver?.disconnect();
      this._pt9001Cleanup?.(); this._pt9001Cleanup = null;
    }
  }
  customElements.define(tag, Pusun9001Highlights);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pusun-pt-max-c-training"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pusun-max-c-training-v9-clearance')) {
  customElements.define('pusun-max-c-training-v9-clearance', class extends HTMLElement {
    connectedCallback() {
      if (this.controller && this.tabsSlot === this.querySelector('[data-tabs-slot]')) return;
      const generation = this.generation = (this.generation || 0) + 1;
      this.readyObserver?.disconnect();
      const initializeWhenReady = () => {
        if (!this.isConnected || generation !== this.generation) return;
        // Shopify may connect a theme block before its children finish parsing.
        if (!this.querySelector('[data-pmt-ready]')) return;
        this.readyObserver?.disconnect();
        this.setup();
      };
      if (this.querySelector('[data-pmt-ready]')) queueMicrotask(initializeWhenReady);
      else {
        this.readyObserver = new MutationObserver(initializeWhenReady);
        this.readyObserver.observe(this, { childList: true, subtree: true });
      }
    }
    setup() {
      const slot = this.querySelector('[data-tabs-slot]');
      const tabBar = this.querySelector('.pmt-tabs');
      const sports = [...this.querySelectorAll('[data-sport]')];
      const tabs = [...this.querySelectorAll('[data-sport-tab]')];
      if (!slot || !tabBar || sports.length !== 2 || tabs.length !== 2) return;
      if (this.controller && this.tabsSlot === slot) return;
      if (this.controller) this.disconnectedCallback();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.motionQuery = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobileQuery = matchMedia('(max-width: 899px)');
      this.sports = sports;
      this.tabs = tabs;
      this.tabsSlot = slot;
      this.tabBar = tabBar;
      this.tabsSlot.hidden = false;
      this.rows = [];
      this.imageIntents = new WeakMap();
      this.mediaRequests = new Map();
      this.mediaMotionStates = new Map();
      this.mediaMotionFrame = 0;
      this.mediaFrames = [...this.querySelectorAll('[data-method-image]')];
      this.updateMediaLayout();
      this.copyWidths = new WeakMap();
      this.videoStates = new WeakMap();
      this.videos = [...this.querySelectorAll('video')];
      this.videos.forEach(video => {
        const state = { visible: false, userPaused: false, internalPause: false, autoStarted: false, blocked: false };
        this.videoStates.set(video, state);
        const frame = video.closest('[data-method-image]');
        const markVideoReady = () => {
          if (video.readyState >= 2 && !video.error) frame?.classList.add('is-video-ready');
        };
        video.addEventListener('loadeddata', markVideoReady, { signal });
        video.addEventListener('playing', markVideoReady, { signal });
        markVideoReady();
        video.controls = false;
        const toggle = video.parentElement.querySelector('[data-video-toggle]');
        const updateControl = () => {
          if (!toggle) return;
          toggle.hidden = video.hidden;
          toggle.dataset.paused = String(video.paused);
          toggle.setAttribute('aria-label', video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
        };
        toggle?.addEventListener('click', () => {
          if (!video.paused) {
            state.userPaused = true;
            this.pauseVideo(video);
          } else {
            state.userPaused = false;
            state.blocked = false;
            state.autoStarted = false;
            video.muted = true;
            const attempt = video.play();
            if (attempt) attempt.catch(() => { state.blocked = true; updateControl(); });
          }
          updateControl();
        }, { signal });
        updateControl();
        video.addEventListener('pause', () => {
          updateControl();
          if (state.internalPause) state.internalPause = false;
          else if (!video.ended && this.videoEligible(video)) state.userPaused = true;
        }, { signal });
        video.addEventListener('play', () => {
          updateControl();
          state.userPaused = false;
          if (!this.videoEligible(video)) this.pauseVideo(video);
        }, { signal });
        video.addEventListener('error', () => {
          this.pauseVideo(video);
          video.hidden = true;
          updateControl();
          frame?.classList.add('is-media-error');
          const fallback = video.parentElement.querySelector('.pmt-video-fallback');
          if (fallback?.classList.contains('pmt-video-fallback')) fallback.hidden = false;
        }, { signal });
      });
      if ('IntersectionObserver' in window) {
        this.mediaObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => { this.videoStates.get(entry.target).visible = entry.isIntersecting; });
          this.syncVideos();
        }, { threshold: 0.05 });
        this.videos.forEach(video => this.mediaObserver.observe(video));
      }
      this.querySelectorAll('.pmt-item').forEach(details => {
        details.removeAttribute('name');
        const summary = details.querySelector('summary');
        const wrap = details.querySelector('.pmt-panel');
        const panel = details.querySelector('.pmt-panel-inner');
        const row = { details, summary, wrap, panel, sport: details.closest('[data-sport]'),
          icon: summary.querySelector('.pmt-toggle-icon'), title: summary.querySelector('.pmt-title'),
          open: details.open, active: false, height: 0, velocity: 0, full: 0,
          width: 0, widthVelocity: 0, fullWidth: 0, closedWidth: 0, frame: 0 };
        this.rows.push(row);
        this.settleRow(row);
        summary.addEventListener('click', event => {
          if (event.defaultPrevented || event.target.closest('a,button,input,select,textarea')) return;
          event.preventDefault();
          this.setRow(row, !row.open);
          if (row.open) this.updateTrainingImage(row.sport, details.dataset.method);
          else this.cancelMediaRequest(row.sport);
          this.syncVideos();
        }, { signal });
        const warmMedia = () => {
          const frame = this.mediaFrames.find(frame => frame.closest('[data-sport]') === row.sport && frame.dataset.methodImage === details.dataset.method);
          this.loadFrame(frame);
        };
        summary.addEventListener('pointerenter', warmMedia, { signal });
        summary.addEventListener('focus', warmMedia, { signal });
        details.addEventListener('toggle', () => {
          if (row.active || details.open === row.open) return;
          row.open = details.open;
          this.settleRow(row);
          if (!row.open) { this.cancelMediaRequest(row.sport); this.syncVideos(); }
          if (row.open) {
            this.setRow(row, true);
            this.updateTrainingImage(row.sport, details.dataset.method);
          }
        }, { signal });
        if ('ResizeObserver' in window) {
          row.resize = new ResizeObserver(() => this.measureRow(row));
          row.resize.observe(panel);
          row.resize.observe(summary);
        }
      });
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.selectSport(tab.dataset.sportTab), { signal });
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.tabs[next].focus({ preventScroll: true });
          this.selectSport(this.tabs[next].dataset.sportTab);
        }, { signal });
      });
      this.sports.forEach(sport => {
        sport.setAttribute('role', 'tabpanel');
        sport.setAttribute('aria-labelledby', this.id + '-tab-' + sport.dataset.sport);
        this.updateTrainingImage(sport, sport.dataset.methodSelected);
      });
      this.classList.add('is-ready');
      this.selectSport(this.dataset.activeSport || this.dataset.defaultSport || 'tennis');
      this.refreshHeaders();
      if ('ResizeObserver' in window) {
        this.layoutObserver = new ResizeObserver(entries => {
          entries.forEach(entry => {
            if (!entry.target.matches('.pmt-copy')) return;
            const width = entry.contentRect.width;
            if (Math.abs(width - (this.copyWidths.get(entry.target) || 0)) < 0.25) return;
            this.copyWidths.set(entry.target, width);
            this.rows.filter(row => row.details.parentElement === entry.target).forEach(row => this.measureRow(row, width));
          });
          this.scheduleSticky();
        });
        [this, this.tabsSlot, ...this.querySelectorAll('.pmt-copy')].forEach(el => this.layoutObserver.observe(el));
      }
      const onScroll = () => {
        this.queueEntranceCheck();
        this.scheduleSticky();
        if (!this.mediaObserver) this.syncVideos();
      };
      document.addEventListener('scroll', onScroll, { capture: true, passive: true, signal });
      window.addEventListener('resize', () => {
        this.settleMediaMotion();
        this.rows.forEach(row => this.measureRow(row));
        this.queueEntranceCheck();
        this.scheduleSticky();
      }, { passive: true, signal });
      this.mobileQuery.addEventListener('change', () => {
        this.sports.forEach(sport => this.cancelMediaRequest(sport));
        this.rows.forEach(row => this.settleRow(row));
        this.updateMediaLayout();
        this.rows.forEach(row => this.measureRow(row));
        this.sports.forEach(sport => this.updateTrainingImage(sport, sport.dataset.methodSelected));
        this.updateHeroVariants(); this.queueEntranceCheck(); this.scheduleSticky();
      }, { signal });
      this.motionQuery.addEventListener('change', () => {
        this.settleMediaMotion();
        if (this.motionQuery.matches) {
          this.rows.forEach(row => this.settleRow(row));
          this.videos.forEach(video => { if (this.videoStates.get(video).autoStarted) this.pauseVideo(video); });
        }
        this.syncVideos();
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) { this.rows.forEach(row => this.settleRow(row)); this.settleMediaMotion(); }
        this.syncVideos(); this.scheduleSticky();
      }, { signal });
      ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(name => {
        document.addEventListener(name, () => { this.refreshHeaders(); this.scheduleSticky(); }, { signal });
      });
      this.headerTransitions = new Map();
      const onHeaderTransition = event => {
        const target = event.target;
        if (!(target instanceof Element) || this.dataset.sticky !== 'true' || this.dataset.stickyMode === 'manual') return;
        if (!this.headers?.some(header => header === target || header.contains(target) || target.contains(header))) return;
        const properties = this.headerTransitions.get(target) || new Map();
        if (event.type === 'transitionrun') {
          // Follow a hide/reveal transition even after scroll events stop.
          // Expire a missing end event if the theme replaces its header mid-transition.
          properties.set(event.propertyName, performance.now() + 5000);
          this.headerTransitions.set(target, properties);
        } else {
          properties.delete(event.propertyName);
          if (!properties.size) this.headerTransitions.delete(target);
        }
        this.scheduleSticky();
      };
      ['transitionrun', 'transitionend', 'transitioncancel'].forEach(name => {
        document.addEventListener(name, onHeaderTransition, { signal });
      });
      this.setupEntranceMotion();
      this.scheduleSticky();
    }
    setupEntranceMotion() {
      this.entranceItems = [...this.querySelectorAll('.pmt-section-heading, .pmt-section-subtitle, .pmt-summary, .pmt-description, .pmt-hero, .pmt-frame')];
      this.entranceShown = this.entranceShown || new WeakSet();
      this.entrancePending = new Set();
      this.entranceAnimations = new Map();
      this.entranceIntersections = new Map();
      const signal = this.controller.signal;
      // Independent translate/scale leave the accordion and media spring transforms intact.
      // Without the required APIs, keep the original component fully visible.
      if (this.motionQuery.matches || !('IntersectionObserver' in window) ||
          !window.CSS?.supports?.('translate', '0 1px') || !window.CSS.supports('scale', '1') ||
          this.entranceItems.some(item => typeof item.animate !== 'function')) return;
      try {
        this.entranceObserver = new IntersectionObserver(entries => {
          if (signal.aborted) return;
          entries.forEach(entry => this.entranceIntersections.set(entry.target, entry.isIntersecting));
          this.queueEntranceCheck();
        }, { root: null, rootMargin: '0px 0px -40px 0px', threshold: 0 });
        this.entranceItems.forEach(item => {
          if (this.entranceShown.has(item)) return;
          item.setAttribute('data-pmt-entrance', item.matches('.pmt-hero, .pmt-frame') ? 'zoom' : 'rise');
          item.setAttribute('data-pmt-entrance-pending', '');
          this.entrancePending.add(item);
          this.entranceObserver.observe(item);
        });
        this.setAttribute('data-pmt-entrance-ready', '');
        this.addEventListener('focusin', event => {
          this.entranceItems.filter(item => item.contains(event.target)).forEach(item => this.finishEntrance(item));
        }, { signal });
        this.motionQuery.addEventListener('change', () => {
          if (this.motionQuery.matches) this.finishAllEntrances();
        }, { signal });
        const selected = event => {
          if (event.target === this || this.contains(event.target) || event.target?.contains?.(this)) this.finishAllEntrances();
        };
        document.addEventListener('shopify:block:select', selected, { signal });
        document.addEventListener('shopify:section:select', selected, { signal });
        window.addEventListener('beforeprint', () => this.finishAllEntrances(), { signal });
        this.queueEntranceCheck();
      } catch (_) {
        this.finishAllEntrances();
        this.removeAttribute('data-pmt-entrance-ready');
      }
    }
    entranceEligible(item) {
      if (!this.isConnected || !item.isConnected || item.closest('[hidden], [inert]')) return false;
      const details = item.closest('details');
      if (details && !details.open && !item.matches('.pmt-summary')) return false;
      const frame = item.closest('.pmt-frame');
      if (frame && !frame.classList.contains('is-active')) return false;
      return item.getClientRects().length > 0 && getComputedStyle(item).visibility !== 'hidden';
    }
    queueEntranceCheck() {
      if (this.entranceCheckFrame || (!this.entrancePending?.size && !this.entranceAnimations?.size)) return;
      this.entranceCheckFrame = requestAnimationFrame(() => {
        this.entranceCheckFrame = 0;
        if (!this.isConnected || this.controller?.signal.aborted) return;
        // Finish an interrupted entry without touching the existing media transition.
        [...this.entranceAnimations.keys()].forEach(item => {
          if (!this.entranceEligible(item)) this.finishEntrance(item);
        });
        const entering = [];
        this.entranceItems.forEach(item => {
          if (!this.entrancePending.has(item) || !this.entranceIntersections.get(item) || !this.entranceEligible(item)) return;
          const rect = item.getBoundingClientRect();
          if (rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight - 40 &&
              rect.right > 0 && rect.left < window.innerWidth) entering.push(item);
        });
        // Read geometry before writing styles; cap stagger so the last item does not lag.
        entering.forEach((item, index) => this.playEntrance(item, Math.min(index, 3) * 90));
      });
    }
    playEntrance(item, delay) {
      if (this.entranceShown.has(item)) return;
      this.entranceShown.add(item);
      this.entrancePending.delete(item);
      this.entranceObserver?.unobserve(item);
      if (this.motionQuery.matches) { this.finishEntrance(item); return; }
      const zoom = item.getAttribute('data-pmt-entrance') === 'zoom';
      const distance = this.mobileQuery.matches ? 32 : 48;
      // Never animate frame opacity: video readiness and lateral crossfades own it.
      const frames = zoom ? [{ scale: '0.94' }, { scale: '1' }] :
        [{ opacity: 0, translate: `0 ${distance}px` }, { opacity: 1, translate: '0 0' }];
      try {
        const animation = item.animate(frames, {
          duration: 1100, delay, easing: 'cubic-bezier(0.16, 1, 0.3, 1)', fill: 'both'
        });
        this.entranceAnimations.set(item, animation);
        item.removeAttribute('data-pmt-entrance-pending');
        animation.finished.then(() => {
          if (this.entranceAnimations.get(item) === animation) this.finishEntrance(item);
        }).catch(() => {
          if (this.entranceAnimations.get(item) === animation) this.finishEntrance(item);
        });
      } catch (_) { this.finishEntrance(item); }
    }
    finishEntrance(item) {
      this.entranceShown?.add(item);
      this.entrancePending?.delete(item);
      this.entranceIntersections?.delete(item);
      this.entranceObserver?.unobserve(item);
      const animation = this.entranceAnimations?.get(item);
      this.entranceAnimations?.delete(item);
      item.removeAttribute('data-pmt-entrance-pending');
      animation?.cancel();
    }
    finishAllEntrances() {
      cancelAnimationFrame(this.entranceCheckFrame); this.entranceCheckFrame = 0;
      this.entranceObserver?.disconnect();
      this.entranceItems?.forEach(item => this.finishEntrance(item));
    }
    selectSport(name) {
      this.settleMediaMotion();
      const selected = this.sports.find(sport => sport.dataset.sport === name) || this.sports[0];
      name = selected.dataset.sport;
      this.dataset.activeSport = name;
      this.tabs.forEach(tab => {
        const active = tab.dataset.sportTab === name;
        tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1;
      });
      this.rows.forEach(row => this.settleRow(row));
      this.sports.forEach(sport => { sport.hidden = sport !== selected; sport.inert = sport !== selected; });
      this.rows.forEach(row => this.measureRow(row));
      this.updateHeroVariants();
      this.queueEntranceCheck();
      this.scheduleSticky();
    }
    updateHeroVariants() {
      const variant = this.mobileQuery.matches ? 'mobile' : 'desktop';
      this.querySelectorAll('[data-hero]').forEach(hero => { hero.hidden = hero.dataset.hero !== variant; });
      this.syncVideos();
    }
    updateMediaLayout() {
      this.settleMediaMotion();
      const mobile = this.mobileQuery.matches;
      (this.mediaFrames || []).forEach(frame => {
        const sport = frame.closest('[data-sport]');
        const gallery = sport.querySelector('.pmt-gallery');
        const inline = [...sport.querySelectorAll('[data-inline-media]')].find(slot => slot.dataset.inlineMedia === frame.dataset.methodImage);
        const target = mobile ? inline : gallery;
        if (target && frame.parentElement !== target) target.append(frame);
      });
      this.querySelectorAll('[data-inline-media]').forEach(slot => { slot.hidden = !mobile || !slot.querySelector('[data-method-image]'); });
      (this.sports || []).forEach(sport => {
        const gallery = sport.querySelector('.pmt-gallery');
        const hasMedia = !!sport.querySelector('[data-method-image].is-active');
        if (gallery) gallery.hidden = mobile || (!hasMedia && !gallery.querySelector('[data-image-placeholder]'));
      });
    }
    mediaRestScale(frame) {
      if (this.mobileQuery.matches || frame.querySelector('video')) return 1;
      return Number.parseFloat(getComputedStyle(this).getPropertyValue('--pmt-image-rest-scale')) || 1;
    }
    mediaMotionState(frame) {
      let state = this.mediaMotionStates.get(frame);
      if (!state) {
        const active = frame.classList.contains('is-active');
        state = { frame, x: 0, y: 0, scale: this.mediaRestScale(frame), opacity: Number(active),
          vx: 0, vy: 0, vs: 0, va: 0, moving: false, shown: active };
        this.mediaMotionStates.set(frame, state);
        frame.setAttribute('data-slide-managed', '');
        this.paintMediaMotion(state);
      }
      return state;
    }
    mediaDirection(sport, method) {
      const methods = [...sport.querySelectorAll('.pmt-item')].map(item => item.dataset.method);
      // Use the displayed mode, not an unfinished loading request, as the origin.
      const current = sport.dataset.mediaMethodShown || sport.querySelector('[data-method-image].is-active')?.dataset.methodImage || sport.dataset.methodSelected;
      const previous = methods.indexOf(current);
      const next = methods.indexOf(method);
      return previous < 0 || next < 0 ? 0 : Math.sign(next - previous);
    }
    mediaSlideDistance(frame) {
      // A short slide keeps the media within its own display area.
      const mobile = this.mobileQuery.matches;
      const width = frame.clientWidth || frame.parentElement?.clientWidth || 320;
      return mobile ? Math.min(32, Math.max(20, width * .08)) : Math.min(64, Math.max(32, width * .1));
    }
    targetMediaMotion(frame, show, direction = 0) {
      const state = this.mediaMotionState(frame);
      const rest = this.mediaRestScale(frame);
      const quiet = this.motionQuery.matches || document.hidden;
      const offset = quiet ? 0 : Math.sign(direction) * this.mediaSlideDistance(frame);
      if (!state.moving && state.shown === show) return;
      if (show && !state.moving && state.opacity < .01) {
        state.x = offset;
        state.vx = state.va = 0;
      }
      // The existing final image size is preserved throughout the transition.
      state.y = 0; state.scale = rest; state.vy = state.vs = 0;
      state.shown = show;
      state.target = { x: show ? 0 : -offset, y: 0, scale: rest, opacity: Number(show) };
      if (quiet) { state.x = 0; state.vx = 0; }
      state.moving = true;
      frame.setAttribute('data-slide-moving', '');
      frame.style.zIndex = show ? '3' : '2';
      this.paintMediaMotion(state);
      if (!this.mediaMotionFrame) {
        this.mediaMotionTime = performance.now();
        this.mediaMotionFrame = requestAnimationFrame(time => this.stepMediaMotion(time));
      }
    }
    stepMediaMotion(time) {
      this.mediaMotionFrame = 0;
      if (!this.isConnected) return;
      const dt = Math.min(Math.max((time - this.mediaMotionTime) / 1000, 0), .05);
      this.mediaMotionTime = time;
      const omega = this.motionQuery.matches ? 42 : 18;
      const decay = Math.exp(-omega * dt);
      let running = false;
      this.mediaMotionStates.forEach(state => {
        if (!state.moving) return;
        let settled = true;
        [['x', 'vx', .3], ['y', 'vy', .3], ['scale', 'vs', .002], ['opacity', 'va', .002]].forEach(([key, velocity, tolerance]) => {
          const displacement = state[key] - state.target[key];
          const carry = state[velocity] + omega * displacement;
          state[key] = state.target[key] + (displacement + carry * dt) * decay;
          state[velocity] = (state[velocity] - omega * carry * dt) * decay;
          if (Math.abs(state[key] - state.target[key]) > tolerance || Math.abs(state[velocity]) > tolerance * 12) settled = false;
        });
        if (settled) {
          Object.assign(state, state.target, { vx: 0, vy: 0, vs: 0, va: 0, moving: false });
          state.frame.removeAttribute('data-slide-moving');
        } else running = true;
        this.paintMediaMotion(state);
      });
      if (running) this.mediaMotionFrame = requestAnimationFrame(next => this.stepMediaMotion(next));
    }
    paintMediaMotion(state) {
      const opacity = Math.max(0, Math.min(1, state.opacity));
      state.frame.style.transform = `translate3d(${state.x.toFixed(3)}px, ${state.y.toFixed(3)}px, 0) scale(${Math.max(.01, state.scale).toFixed(5)})`;
      state.frame.style.opacity = opacity.toFixed(5);
      state.frame.style.visibility = state.moving || opacity > .001 ? 'visible' : 'hidden';
    }
    settleMediaMotion() {
      cancelAnimationFrame(this.mediaMotionFrame); this.mediaMotionFrame = 0;
      this.mediaMotionStates?.forEach(state => {
        const owner = this.rows.find(row => row.sport === state.frame.closest('[data-sport]') && row.details.dataset.method === state.frame.dataset.methodImage);
        const active = state.frame.classList.contains('is-active') && (!this.mobileQuery.matches || !owner || owner.open);
        Object.assign(state, { x: 0, y: 0, scale: this.mediaRestScale(state.frame), opacity: Number(active),
          vx: 0, vy: 0, vs: 0, va: 0, moving: false, shown: active });
        state.frame.removeAttribute('data-slide-moving');
        state.frame.style.removeProperty('z-index');
        this.paintMediaMotion(state);
      });
    }
    cancelMediaRequest(sport) {
      this.mediaRequests?.get(sport)?.abort();
      this.mediaRequests?.delete(sport);
      this.imageIntents.set(sport, (this.imageIntents.get(sport) || 0) + 1);
      sport.querySelectorAll('.is-media-pending').forEach(row => row.classList.remove('is-media-pending'));
      sport.querySelectorAll('.pmt-panel[aria-busy]').forEach(panel => panel.removeAttribute('aria-busy'));
    }
    loadFrame(frame) {
      if (!frame) return;
      frame.querySelectorAll('img').forEach(image => { image.loading = 'eager'; image.decoding = 'async'; });
      const video = frame.querySelector('video');
      const state = this.videoStates?.get(video);
      if (video && !video.error && video.readyState < 2 && !state?.preloaded) {
        if (state) state.preloaded = true;
        video.preload = 'auto'; video.load();
      }
    }
    prepareFrame(frame, signal) {
      if (!frame) return Promise.resolve();
      const video = frame.querySelector('video');
      const image = frame.querySelector('img');
      return new Promise(resolve => {
        let timer;
        const ready = () => video ? video.readyState >= 2 || video.error || (image?.complete && image.naturalWidth > 0) : !image || image.complete;
        const finish = () => {
          clearTimeout(timer);
          signal.removeEventListener('abort', finish);
          video?.removeEventListener('loadeddata', check); video?.removeEventListener('error', check);
          image?.removeEventListener('load', check); image?.removeEventListener('error', check);
          resolve();
        };
        const check = () => { if (ready()) finish(); };
        if (signal.aborted) { finish(); return; }
        signal.addEventListener('abort', finish, { once: true });
        video?.addEventListener('loadeddata', check); video?.addEventListener('error', check);
        image?.addEventListener('load', check); image?.addEventListener('error', check);
        // A timeout does not mark media ready: the poster/loading state remains visible.
        timer = setTimeout(finish, 8000);
        this.loadFrame(frame);
        check();
      });
    }
    async updateTrainingImage(sport, method) {
      this.cancelMediaRequest(sport);
      const generation = this.generation;
      const intent = this.imageIntents.get(sport);
      const request = new AbortController();
      this.mediaRequests.set(sport, request);
      sport.dataset.methodSelected = method || '';
      const selected = [...sport.querySelectorAll('[data-method-image]')].find(frame => frame.dataset.methodImage === method);
      const row = this.rows.find(row => row.sport === sport && row.details.dataset.method === method);
      row?.details.classList.add('is-media-pending');
      row?.wrap.setAttribute('aria-busy', 'true');
      await this.prepareFrame(selected, request.signal);
      if (request.signal.aborted || !this.isConnected || generation !== this.generation || this.imageIntents.get(sport) !== intent) return;
      this.mediaRequests.delete(sport);
      row?.details.classList.remove('is-media-pending'); row?.wrap.removeAttribute('aria-busy');
      let hasMedia = false;
      const frames = [...sport.querySelectorAll('[data-method-image]')];
      const direction = this.mediaDirection(sport, method);
      sport.dataset.mediaMethodShown = method || '';
      frames.forEach(frame => this.mediaMotionState(frame));
      frames.forEach(frame => {
        const active = frame === selected;
        frame.classList.toggle('is-active', active);
        frame.setAttribute('aria-hidden', String(!active)); frame.inert = !active;
        if (active) hasMedia = true;
      });
      const placeholder = sport.querySelector('[data-image-placeholder]');
      if (placeholder) placeholder.hidden = hasMedia;
      const gallery = sport.querySelector('.pmt-gallery');
      if (gallery) gallery.hidden = this.mobileQuery.matches || (!hasMedia && !placeholder);
      sport.querySelector('.pmt-content')?.classList.toggle('pmt-content--text-only', !hasMedia && !placeholder);
      if (row) this.measureRow(row);
      frames.forEach(frame => this.targetMediaMotion(frame, frame === selected, direction));
      this.syncVideos(); this.queueEntranceCheck(); this.scheduleSticky();
    }
    videoEligible(video) {
      if (document.hidden || video.hidden || video.closest('[data-sport]')?.hidden) return false;
      const hero = video.closest('[data-hero]');
      if (hero?.hidden) return false;
      const frame = video.closest('[data-method-image]');
      if (frame && !frame.classList.contains('is-active')) return false;
      const details = video.closest('.pmt-item');
      if (this.mobileQuery.matches && details) {
        const row = this.rows.find(row => row.details === details);
        if (!row?.open || details.querySelector('.pmt-panel')?.inert) return false;
      }
      if (this.mediaObserver) return this.videoStates.get(video)?.visible;
      const rect = video.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight;
    }
    pauseVideo(video) {
      const state = this.videoStates?.get(video);
      if (!video.paused) { if (state) state.internalPause = true; video.pause(); }
      if (state) state.autoStarted = false;
    }
    syncVideos() {
      (this.videos || []).forEach(video => {
        const state = this.videoStates.get(video);
        if (!this.videoEligible(video)) { this.pauseVideo(video); return; }
        if (this.dataset.autoplay !== 'true' || this.motionQuery.matches || state.userPaused || state.blocked || !video.paused) return;
        video.muted = true; state.autoStarted = true;
        const attempt = video.play();
        if (attempt) attempt.catch(error => {
          // An interrupted sport/viewport change is retryable; a denied autoplay is not.
          if (error.name !== 'AbortError') state.blocked = true;
          state.autoStarted = false;
        });
      });
    }
    refreshHeaders() {
      let selector = 'header, header-component, [data-product-nav], [data-product-navigation], [data-sticky-header], .shopify-section-group-header-group';
      const custom = this.dataset.headerSelector?.trim();
      if (custom) { try { document.querySelector(custom); selector += ', ' + custom; } catch (_) { /* Manual offset remains available. */ } }
      this.headers = [...document.querySelectorAll(selector)].filter(header => !this.contains(header));
    }
    headerOffset() {
      const extra = Number(this.mobileQuery.matches ? this.dataset.offsetMobile : this.dataset.offset) || 0;
      if (this.dataset.stickyMode === 'manual') return Math.max(0, extra);
      const intervals = [];
      (this.headers || []).forEach(header => {
        if (!header.isConnected || header.closest('[hidden]')) return;
        let node = header, anchored = false;
        while (node && node !== document.body) {
          const position = getComputedStyle(node).position;
          if (position === 'fixed' || position === 'sticky') { anchored = true; break; }
          node = node.parentElement;
        }
        if (!anchored) return;
        const rect = header.getBoundingClientRect();
        if (rect.width && rect.bottom > 0 && rect.top < innerHeight / 2 && rect.height < Math.min(360, innerHeight * .6)) intervals.push(rect);
      });
      intervals.sort((a, b) => a.top - b.top);
      let bottom = 0;
      intervals.forEach(rect => { if (rect.top <= bottom + 16) bottom = Math.max(bottom, rect.bottom); });
      return bottom + extra;
    }
    scheduleSticky() {
      if (this.stickyFrame || !this.controller || !this.tabsSlot) return;
      this.stickyFrame = requestAnimationFrame(() => { this.stickyFrame = 0; this.updateSticky(); });
    }
    updateTabsClearance(stuck) {
      const slot = this.tabsSlot;
      const bar = this.tabBar;
      if (!slot || !bar) return;
      const sport = this.sports.find(sport => !sport.hidden);
      const slotRect = slot.getBoundingClientRect();
      const oldRect = bar.getBoundingClientRect();
      const previousShift = this.tabsShift || 0;
      const baseLeft = oldRect.left - previousShift;
      let shift = 0;
      if (stuck && sport && !this.mobileQuery.matches) {
        const gallery = sport.querySelector('.pmt-gallery');
        const copy = sport.querySelector('.pmt-copy');
        const copyRect = copy?.getBoundingClientRect();
        if (gallery && !gallery.hidden && copyRect && copyRect.width >= oldRect.width + 24) {
          // Mirror automatically when media is on the left. Never dock over it.
          const desiredLeft = copyRect.left + (copyRect.width - oldRect.width) / 2;
          const left = Math.max(slotRect.left, Math.min(desiredLeft, slotRect.right - oldRect.width));
          shift = left - baseLeft;
        }
      }
      this.tabsShift = shift;
      const cssShift = shift.toFixed(3) + 'px';
      if (slot.style.getPropertyValue('--pmt-tabs-shift') !== cssShift) slot.style.setProperty('--pmt-tabs-shift', cssShift);
      if (!stuck || !sport) { slot.removeAttribute('data-media-overlap'); return; }
      // Use the final translated bounds without another forced layout read.
      const bounds = { left: baseLeft + shift, right: baseLeft + shift + oldRect.width,
        top: oldRect.top, bottom: oldRect.bottom };
      const wasOverlapping = slot.hasAttribute('data-media-overlap');
      const gap = wasOverlapping ? 20 : 12; // Hysteresis avoids flicker at the edge.
      const media = [...sport.querySelectorAll('[data-hero]:not([hidden]), [data-method-image]')];
      const overlap = media.some(surface => {
        if (surface.hidden || surface.closest('[hidden]') || !surface.getClientRects().length) return false;
        if (surface.matches('[data-method-image]')) {
          const state = this.mediaMotionStates.get(surface);
          if (!surface.classList.contains('is-active') && !(state?.moving && state.opacity > .01)) return false;
          if (state && state.opacity <= .01) return false;
        }
        let rect = surface.getBoundingClientRect();
        // Inline media can extend beyond a closing accordion's visible crop.
        const details = surface.closest('.pmt-item');
        if (details) {
          const crop = details.getBoundingClientRect();
          rect = {left:Math.max(rect.left,crop.left),right:Math.min(rect.right,crop.right),
            top:Math.max(rect.top,crop.top),bottom:Math.min(rect.bottom,crop.bottom)};
        }
        if (rect.right <= rect.left || rect.bottom <= rect.top) return false;
        return rect.left < bounds.right + gap && rect.right > bounds.left - gap &&
          rect.top < bounds.bottom + gap && rect.bottom > bounds.top - gap;
      });
      // Keep layout space intact; only the compact bar hides, without page jumps.
      // A keyboard-focused bar remains visible so focus is never hidden mid-use.
      slot.toggleAttribute('data-media-overlap', overlap);
    }
    updateSticky() {
      if (!this.isConnected || !this.tabsSlot) return;
      const enabled = this.dataset.sticky === 'true';
      const top = enabled ? this.headerOffset() : 0;
      const value = Math.max(0, top).toFixed(2) + 'px';
      if (this.tabsSlot.style.getPropertyValue('--pmt-sticky-top') !== value) {
        this.tabsSlot.style.setProperty('--pmt-sticky-top', value);
      }
      // Native sticky handles scrolling and the component's bottom boundary.
      // Never compensate scroll with a delayed transform on the moving tab bar.
      const stuck = enabled && this.tabsSlot.getBoundingClientRect().top <= top + 1;
      this.toggleAttribute('data-stuck', stuck);
      this.updateTabsClearance(stuck);
      const now = performance.now();
      this.headerTransitions?.forEach((properties, target) => {
        properties.forEach((expires, property) => {
          if (!target.isConnected || expires <= now) properties.delete(property);
        });
        if (!properties.size) this.headerTransitions.delete(target);
      });
      if (enabled && (this.headerTransitions?.size || this.mediaMotionFrame || this.rows.some(row => row.active))) this.scheduleSticky();
    }
      measureRow(row, availableWidth) {
        if (row.sport.hidden) return;
        row.fullWidth = availableWidth ?? row.details.parentElement.getBoundingClientRect().width;
        const panelWidth = row.fullWidth + 'px';
        if (row.details.style.getPropertyValue('--pmt-panel-width') !== panelWidth) {
          row.details.style.setProperty('--pmt-panel-width', panelWidth);
        }
        // The inner copy keeps its final width while the outer capsule reveals it.
        // Only clicks, content/font changes and container resizes need measurements.
        row.closedWidth = Math.min(row.fullWidth, row.summary.getBoundingClientRect().width);
        if (row.details.open) row.full = row.panel.getBoundingClientRect().height;
      }
      setRow(row, open, direction = 0) {
        if (open) {
          direction = this.mediaDirection(row.sport, row.details.dataset.method);
          this.rows.forEach(other => {
            if (other !== row && other.sport === row.sport && other.open) this.setRow(other, false, direction);
          });
        }
        if (row.open === open) {
          if (row.active && (this.motionQuery.matches || document.hidden)) this.settleRow(row);
          return;
        }
        const wasActive = row.active;
        if (!wasActive) {
          row.height = row.details.open ? row.wrap.getBoundingClientRect().height : 0;
          row.width = row.details.getBoundingClientRect().width;
          row.velocity = 0;
          row.widthVelocity = 0;
        }
        row.open = open;
        if (!open && this.mobileQuery.matches) {
          const media = row.panel.querySelector('[data-method-image]');
          if (media) this.targetMediaMotion(media, false, direction);
        }
        row.summary.setAttribute('aria-expanded', String(open));
        row.wrap.inert = !open;
        row.wrap.setAttribute('aria-hidden', String(!open));
        if (!open && row.wrap.contains(document.activeElement)) row.summary.focus({ preventScroll: true });
        if (this.motionQuery.matches || document.hidden) { this.settleRow(row); return; }
        row.active = true;
        row.details.style.width = row.width + 'px';
        row.wrap.style.height = row.height + 'px';
        row.wrap.style.overflow = 'clip';
        // Keep native details open while closing, so following items move continuously.
        row.details.open = true;
        this.measureRow(row);
        this.paintRow(row);
        if (!wasActive) {
          row.previousTime = performance.now();
          row.frame = requestAnimationFrame(time => this.stepRow(row, time));
        }
      }
      stepRow(row, time) {
        if (!this.isConnected || !row.active) return;
        const dt = Math.min(Math.max((time - row.previousTime) / 1000, 0), 0.05);
        row.previousTime = time;
        const target = row.open ? row.full : 0;
        const targetWidth = row.open ? row.fullWidth : row.closedWidth;
        const omega = 24;
        // One critically damped spring for both axes; preserve both velocities on reversal.
        const displacement = row.height - target;
        const carry = row.velocity + omega * displacement;
        const decay = Math.exp(-omega * dt);
        row.height = target + (displacement + carry * dt) * decay;
        row.velocity = (row.velocity - omega * carry * dt) * decay;
        const widthDisplacement = row.width - targetWidth;
        const widthCarry = row.widthVelocity + omega * widthDisplacement;
        row.width = targetWidth + (widthDisplacement + widthCarry * dt) * decay;
        row.widthVelocity = (row.widthVelocity - omega * widthCarry * dt) * decay;
        if (Math.abs(row.height - target) < 0.5 && Math.abs(row.velocity) < 8 &&
            Math.abs(row.width - targetWidth) < 0.5 && Math.abs(row.widthVelocity) < 8) {
          this.settleRow(row); return;
        }
        this.paintRow(row);
        row.frame = requestAnimationFrame(next => this.stepRow(row, next));
      }
      paintRow(row) {
        row.details.style.width = Math.max(0, row.width) + 'px';
        row.wrap.style.height = Math.max(0, row.height) + 'px';
        const progress = row.full > 0 ? row.height / row.full :
          row.fullWidth > row.closedWidth ? (row.width - row.closedWidth) / (row.fullWidth - row.closedWidth) : Number(row.open);
        const reveal = Math.min(1, Math.max(0, progress));
        row.icon.style.opacity = String(1 - reveal);
        row.icon.style.visibility = reveal < 0.999 ? 'visible' : 'hidden';
        row.title.style.transform = 'translateX(calc(var(--pmt-toggle-space) * ' + -reveal + '))';
      }
      settleRow(row) {
        cancelAnimationFrame(row.frame);
        row.frame = 0;
        row.active = false;
        row.velocity = 0;
        row.widthVelocity = 0;
        row.details.open = row.open;
        row.summary.setAttribute('aria-expanded', String(row.open));
        row.wrap.inert = !row.open;
        row.wrap.setAttribute('aria-hidden', String(!row.open));
        row.wrap.style.removeProperty('height');
        row.wrap.style.removeProperty('overflow');
        row.details.style.removeProperty('width');
        row.icon.style.removeProperty('transform');
        row.icon.style.removeProperty('opacity');
        row.icon.style.removeProperty('visibility');
        row.title.style.removeProperty('transform');
      }

    disconnectedCallback() {
      this.finishAllEntrances();
      this.removeAttribute('data-pmt-entrance-ready');
      this.generation = (this.generation || 0) + 1;
      this.readyObserver?.disconnect();
      this.settleMediaMotion();
      this.mediaMotionStates?.clear();
      (this.sports || []).forEach(sport => this.cancelMediaRequest(sport));
      (this.videos || []).forEach(video => this.pauseVideo(video));
      this.mediaObserver?.disconnect(); this.layoutObserver?.disconnect();
      this.controller?.abort();
      (this.rows || []).forEach(row => { row.resize?.disconnect(); this.settleRow(row); });
      cancelAnimationFrame(this.stickyFrame); this.stickyFrame = 0;
      this.tabsSlot?.style.removeProperty('--pmt-sticky-top');
      this.tabsSlot?.style.removeProperty('--pmt-tabs-shift');
      this.tabsSlot?.removeAttribute('data-media-overlap');
      this.tabsShift = 0;
      this.headerTransitions?.clear();
      this.removeAttribute('data-stuck');
      this.controller = null;
    }
  });
  // Re-rendering can replace the root or, in some editors, only its inner content.
  document.addEventListener('shopify:section:load', event => {
    const host = event.target;
    if (!(host instanceof Element)) return;
    const blocks = [...host.querySelectorAll('pusun-max-c-training-v9-clearance')];
    if (host.matches('pusun-max-c-training-v9-clearance')) blocks.unshift(host);
    blocks.forEach(block => block.connectedCallback());
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pusun-pt-smart-pro-faq"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag = 'pusun-smart-pro-faq';
  if (customElements.get(tag)) return;

  // Exact critically damped spring integration; retargets keep position and velocity.
  function springStep(position, velocity, target, dt, omega) {
    const offset = position - target;
    const momentum = velocity + omega * offset;
    const decay = Math.exp(-omega * dt);
    return {
      position: target + (offset + momentum * dt) * decay,
      velocity: (velocity - omega * momentum * dt) * decay
    };
  }

  class PusunSmartProFAQ extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      if (!this.querySelector('[data-faq-ready]')) {
        this.parserObserver?.disconnect();
        this.parserObserver = new MutationObserver(() => this.connectedCallback());
        this.parserObserver.observe(this, {childList: true, subtree: true});
        return;
      }
      this.parserObserver?.disconnect();
      this.controller = new AbortController();
      const {signal} = this.controller;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.omega = Math.min(20, Math.max(8, Number(this.dataset.omega) || 12));
      this.singleOpen = this.dataset.single === 'true';
      this.states = new Map();
      this.active = new Set();
      this.frame = 0;

      this.querySelectorAll('[data-faq-item]').forEach(item => {
        const summary = item.querySelector('summary');
        const answer = item.querySelector('[data-faq-answer]');
        const inner = item.querySelector('[data-faq-inner]');
        const natural = item.open ? inner.getBoundingClientRect().height : 0;
        const state = {item, summary, answer, inner, x: natural, v: 0, target: natural, natural, opening: item.open};
        this.states.set(item, state);
        item.dataset.expanded = String(item.open);
        summary.setAttribute('aria-expanded', String(item.open));
        answer.inert = !item.open;
        answer.setAttribute('aria-hidden', String(!item.open));
        summary.addEventListener('click', event => {
          event.preventDefault();
          this.toggleItem(item, !state.opening);
        }, {signal});
      });

      if ('ResizeObserver' in window) {
        // Observe intrinsic content, not the animated height: no resize feedback loop.
        this.resize = new ResizeObserver(entries => {
          entries.forEach(entry => {
            const state = this.states.get(entry.target.closest('[data-faq-item]'));
            if (!state || !state.item.open) return;
            const natural = entry.target.getBoundingClientRect().height;
            state.natural = natural;
            if (state.opening) {
              state.target = natural;
              if (!this.active.has(state)) state.x = natural;
            }
          });
        });
        this.states.forEach(state => this.resize.observe(state.inner));
      }

      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.finishMotion();
      }, {signal});
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.finishMotion();
      }, {signal});
      window.addEventListener('beforeprint', () => this.finishMotion(), {signal});
      document.addEventListener('shopify:block:select', event => {
        if (!(event.target instanceof Element)) return;
        const item = event.target.closest('[data-faq-item]');
        if (this.states.has(item)) this.toggleItem(item, true);
      }, {signal});
      this.dataset.enhanced = 'true';
    }

    toggleItem(item, opening) {
      if (opening && this.singleOpen) {
        this.states.forEach(state => {
          if (state.item !== item && state.opening) this.setOpen(state.item, false);
        });
      }
      this.setOpen(item, opening);
    }

    setOpen(item, opening) {
      const state = this.states.get(item);
      if (!state || state.opening === opening) return;
      const {answer, inner, summary} = state;
      if (!this.active.has(state)) {
        state.x = item.open ? answer.getBoundingClientRect().height : 0;
        state.v = 0;
      }
      state.opening = opening;
      item.dataset.expanded = String(opening);
      summary.setAttribute('aria-expanded', String(opening));
      if (!opening && answer.contains(document.activeElement)) summary.focus({preventScroll: true});
      answer.inert = !opening;
      answer.setAttribute('aria-hidden', String(!opening));
      answer.style.height = `${state.x}px`;
      // Keep native details open throughout closing; remove open only at rest.
      item.open = true;
      state.natural = inner.getBoundingClientRect().height;
      state.target = opening ? state.natural : 0;
      this.draw(state);
      if (this.motion.matches || document.hidden || (Math.abs(state.x - state.target) < .1 && Math.abs(state.v) < 1)) {
        this.settle(state);
        return;
      }
      this.active.add(state);
      if (!this.frame) {
        this.lastTime = performance.now();
        this.frame = requestAnimationFrame(time => this.tick(time));
      }
    }

    draw(state) {
      state.answer.style.height = `${Math.max(0, state.x)}px`;
      const progress = state.natural ? Math.max(0, Math.min(1, state.x / state.natural)) : Number(state.opening);
      state.item.style.setProperty('--psf-progress', String(progress));
    }

    tick(time) {
      this.frame = 0;
      if (!this.isConnected) { this.finishMotion(); return; }
      const dt = Math.min(Math.max(0, (time - this.lastTime) / 1000), .05);
      this.lastTime = time;
      this.active.forEach(state => {
        const next = springStep(state.x, state.v, state.target, dt, this.omega);
        state.x = next.position;
        state.v = next.velocity;
        if (state.x < 0) { state.x = 0; state.v = 0; }
        if (Math.abs(state.x - state.target) < .1 && Math.abs(state.v) < 1) this.settle(state);
        else this.draw(state);
      });
      if (this.active.size) this.frame = requestAnimationFrame(next => this.tick(next));
    }

    settle(state) {
      state.x = state.target;
      state.v = 0;
      state.item.open = state.opening;
      state.answer.inert = !state.opening;
      state.answer.style.removeProperty('height');
      state.item.style.removeProperty('--psf-progress');
      this.active.delete(state);
    }

    finishMotion() {
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.active?.forEach(state => this.settle(state));
    }

    disconnectedCallback() {
      this.parserObserver?.disconnect();
      this.resize?.disconnect();
      this.controller?.abort();
      this.finishMotion();
      // Restore native details behavior if this element is reinserted without JS.
      this.states?.forEach(state => {
        state.summary.removeAttribute('aria-expanded');
        state.answer.removeAttribute('aria-hidden');
        state.answer.inert = false;
        delete state.item.dataset.expanded;
      });
      this.controller = null;
      delete this.dataset.enhanced;
    }
  }
  customElements.define(tag, PusunSmartProFAQ);
})();


  } catch(e) { console.error(e); }
})();
})();
